import React, { useState, useContext, useEffect, useMemo, useCallback, useRef } from "react";
import FichasMonitorDialog from "../components/FichasMonitorDialog";
import clsx from "clsx";
import { useHistory, useLocation } from "react-router-dom";
import {
  makeStyles,
  Drawer,
  AppBar,
  Toolbar,
  List,
  Typography,
  Divider,
  Button,
  MenuItem,
  IconButton,
  ButtonBase,
  Menu,
  useTheme,
  useMediaQuery,
  Avatar,
  Badge,
  withStyles,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  ListItem,
  ListItemAvatar,
  ListItemText,
  BottomNavigation,
  BottomNavigationAction,
  Tooltip,
  Popover,
  Slider,
  Switch,
  TextField,
  CircularProgress,
} from "@material-ui/core";
import FormatSizeIcon from "@material-ui/icons/FormatSize";
import MenuIcon from "@material-ui/icons/Menu";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import NotificationsIcon from "@material-ui/icons/Notifications";
import CloseIcon from "@material-ui/icons/Close";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import RefreshIcon from "@material-ui/icons/Refresh";
import AssignmentIndIcon from "@material-ui/icons/AssignmentInd";
import BarChartIcon from "@material-ui/icons/BarChart";
import LocalAtmIcon from "@material-ui/icons/LocalAtm";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import BuildOutlinedIcon from "@material-ui/icons/BuildOutlined";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import SmartphoneIcon from "@material-ui/icons/Smartphone";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import SearchIcon from "@material-ui/icons/Search";
import SettingsOutlinedIcon from "@material-ui/icons/SettingsOutlined";
import ContactsOutlinedIcon from "@material-ui/icons/ContactsOutlined";
import MonetizationOnOutlinedIcon from "@material-ui/icons/MonetizationOnOutlined";
import ChatBubbleOutlineIcon from "@material-ui/icons/ChatBubbleOutline";
import CreateIcon from "@material-ui/icons/Create";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import MotorcycleOutlinedIcon from "@material-ui/icons/MotorcycleOutlined";
import MotorcycleIcon from "@material-ui/icons/Motorcycle";
import ReceiptIcon from "@material-ui/icons/Receipt";
import PixSheetModal from "../components/PixSheetModal";
import SolteSheetModal from "../components/SolteSheetModal";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import api from "../services/api";
import MainListItems from "./MainListItems";
import UserModal from "../components/UserModal";
import { AuthContext } from "../context/Auth/AuthContext";
import BackdropLoading from "../components/BackdropLoading";
import { i18n } from "../translate/i18n";
import toastError from "../errors/toastError";
import BirthdayModal from "../components/BirthdayModal";
import { getBackendUrl } from "../config";
import useSocketListener from "../hooks/useSocketListener";
import { toast } from "react-toastify";
import NewTicketModal from "../components/NewTicketModal";
import { WhatsAppsContext } from "../context/WhatsApp/WhatsAppsContext";
import PWAInstallPrompt from "../components/PWAInstallPrompt";
import WebPushManager from "../components/WebPushManager";
import useIsDesktopAppLayout from "../hooks/useIsDesktopAppLayout";
import useIsStandalonePwa from "../hooks/useIsStandalonePwa";
import isEquipeChatDesktopShell from "../utils/isEquipeChatDesktopShell";
import isEquipeChatMobileApp from "../utils/isEquipeChatMobileApp";
import isXaiLeadProfile from "../utils/isXaiLeadProfile";
import { LEAD_ROUTE_CONFIG } from "../utils/leadFunnels";
import { setTelegramEditMode, getTelegramEditMode } from "../utils/telegramEditMode";
import { getCachedTicketMessages, mergeCachedTicketMessages } from "../utils/messageCache";
import { startRegistrationsAutoSync } from "../utils/registrationsCache";
import {
  isBiometricSupported,
  getBiometryInfo,
  getBiometryLabel,
  authenticateWithBiometric,
  saveBiometricCredentials,
  loadBiometricCredentials,
  clearBiometricCredentials,
} from "../utils/biometricAuth";
import {
  isWebPushSupported,
  getWebPushPermission,
  requestWebPushPermission,
  subscribeWebPush,
  unsubscribeWebPush,
} from "../utils/webPushManager";

const backendUrl = getBackendUrl();
const drawerWidth = 240;
const desktopShellRailWidth = 68;
const appBarHeight = 48;
const REGISTRATION_EXPORT_OVERDUE_EVENT = "contact-registrations:export-overdue";
const REGISTRATION_EXPORT_SPREADSHEET_EVENT = "contact-registrations:export-spreadsheet";
const MAIN_SCROLL_STORAGE_KEY = "layout.mainScrollPositions.v1";
const getDuePreviewStorageKey = (companyId) =>
  `registrationDuePreviewState:${Number(companyId || 0)}`;

const readMainScrollStorage = () => {
  if (typeof window === "undefined") {
    return {};
  }

  try {
    const raw = window.sessionStorage.getItem(MAIN_SCROLL_STORAGE_KEY);
    if (!raw) {
      return {};
    }

    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) {
      return {};
    }

    return parsed;
  } catch (_error) {
    return {};
  }
};

const writeMainScrollStorage = (value) => {
  if (typeof window === "undefined") {
    return;
  }

  try {
    window.sessionStorage.setItem(
      MAIN_SCROLL_STORAGE_KEY,
      JSON.stringify(value && typeof value === "object" ? value : {})
    );
  } catch (_error) {
    // ignore sessionStorage write error
  }
};

const readDuePreviewStorage = (companyId) => {
  try {
    const key = getDuePreviewStorageKey(companyId);
    const raw = localStorage.getItem(key);
    if (!raw) {
      return null;
    }

    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") {
      return null;
    }

    return {
      data: parsed.data || null,
      dismissed: Boolean(parsed.dismissed),
      generatedAt: String(parsed.generatedAt || "")
    };
  } catch (error) {
    return null;
  }
};

const writeDuePreviewStorage = (companyId, value) => {
  try {
    const key = getDuePreviewStorageKey(companyId);
    localStorage.setItem(key, JSON.stringify(value || {}));
  } catch (error) {
    // ignore localStorage error
  }
};


const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    height: "100vh",
    [theme.breakpoints.down("sm")]: {
      height: "100dvh",
    },
    backgroundColor: theme.palette.fancyBackground,
    "& .MuiButton-outlinedPrimary": {
      color: theme.palette.primary.main, // Usa cor do tema
      border: `1px solid ${theme.palette.primary.main}40`,
      borderRadius: "8px",
      fontWeight: 600,
      textTransform: "none",
      transition: "all 0.3s ease",
      "&:hover": {
        backgroundColor: `${theme.palette.primary.main}10`,
        borderColor: theme.palette.primary.main,
        transform: "translateY(-1px)",
        boxShadow: `0 4px 12px ${theme.palette.primary.main}30`,
      },
    },
    "& .MuiTab-textColorPrimary.Mui-selected": {
      color: theme.palette.primary.main, // Usa cor do tema
      fontWeight: 700,
    },
  },

  chip: {
    background: "red",
    color: "white",
  },

  avatar: {
    width: "100%",
  },

  toolbar: {
    paddingRight: 24,
    color: theme.palette.primary.main,
    background: theme.palette.total,
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    transition: "all 0.3s ease",
  },

  toolbarIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0 8px",
    minHeight: "48px",
    [theme.breakpoints.down("sm")]: {
      height: "48px",
    },
    backgroundColor: theme.palette.optionsBackground,
    borderBottom: `1px solid ${theme.palette.divider}`, // Linha sutil para separação
    transition: "all 0.3s ease",
  },

  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },

  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },

  menuButtonHidden: {
    display: "none",
  },

  title: {
    flexGrow: 1,
    fontSize: 18,
    color: theme.palette.primary.main,
    fontWeight: 700,
    letterSpacing: "0.03em",
    [theme.breakpoints.down("sm")]: {
      fontSize: 16,
    },
  },

  drawerPaper: {
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: "hidden",
    overflowY: "hidden",
    backgroundColor: theme.palette.total,
    // Melhorias sutis no drawer
    borderRight: `1px solid ${theme.mode === "light" ? "#e0e0e0" : "#424242"}`,
    boxShadow:
      theme.mode === "light"
        ? "2px 0 8px rgba(0, 0, 0, 0.1)"
        : "2px 0 8px rgba(0, 0, 0, 0.3)",
  },

  drawerPaperClose: {
    overflowX: "hidden",
    overflowY: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9),
    },
  },

  appBarSpacer: {
    minHeight: "48px",
  },

  appBarSpacerTelegram: {
    minHeight: "104px",
  },

  contentWithMobileNavTelegram: {
    paddingBottom: "calc(150px + env(safe-area-inset-bottom, 0px))",
  },

  content: {
    flex: 1,
    overflow: "auto",
    padding: 0,
    margin: 0,
    backgroundColor: theme.palette.fancyBackground,
  },

  contentWithMobileNav: {
    paddingBottom: "env(safe-area-inset-bottom, 0px)",
  },

  contentTicketConversationMobile: {
    overflow: "hidden",
    overscrollBehavior: "none",
    WebkitOverflowScrolling: "auto",
  },

  container: {
    padding: 0,
    margin: 0,
    maxWidth: "none",
    width: "100%",
  },

  containerWithScroll: {
    flex: 1,
    overflowY: "scroll",
    overflowX: "hidden",
    ...theme.scrollbarStyles,
    backgroundColor: theme.palette.total,
    borderRadius: "8px",
    border: "2px solid transparent",
    "&::-webkit-scrollbar": {
      display: "none",
    },
    "-ms-overflow-style": "none",
    "scrollbar-width": "none",
  },

  mobileBottomNavShell: {
    position: "fixed",
    left: 20,
    right: 20,
    bottom: 0,
    zIndex: theme.zIndex.drawer + 3,
    background: theme.palette.type === "dark"
      ? "rgba(18, 18, 20, 0.38)"
      : "rgba(255, 255, 255, 0.38)",
    backdropFilter: "blur(22px) saturate(1.6)",
    WebkitBackdropFilter: "blur(22px) saturate(1.6)",
    borderRadius: 28,
    overflow: "hidden",
    border: `1px solid ${theme.palette.type === "dark" ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.06)"}`,
    boxShadow: theme.palette.type === "dark"
      ? "0 6px 24px rgba(0,0,0,0.40)"
      : "0 6px 22px rgba(0,0,0,0.10)",
  },

  bottomNavCover: {
    position: "fixed",
    left: 0,
    right: 0,
    bottom: 0,
    height: "calc(12px + env(safe-area-inset-bottom, 0px))",
    background: "transparent",
    zIndex: theme.zIndex.drawer + 2,
    pointerEvents: "none",
  },

  mobileTopGradient: {
    position: "fixed",
    left: 0,
    right: 0,
    // começa ABAIXO do header (paddingTop 13px + row 44px = 57px + safe-area)
    top: "calc(57px + env(safe-area-inset-top, 0px))",
    height: 48,
    background: theme.palette.type === "dark"
      ? "linear-gradient(to bottom, rgba(0,0,0,0.88) 0%, rgba(0,0,0,0) 100%)"
      : "linear-gradient(to bottom, rgba(239,239,244,0.92) 0%, rgba(239,239,244,0) 100%)",
    pointerEvents: "none",
    zIndex: theme.zIndex.drawer + 1,
  },

  mobileBottomGradient: {
    position: "fixed",
    left: 0,
    right: 0,
    bottom: 0,
    height: 130,
    background: theme.palette.type === "dark"
      ? "linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,0.82) 45%, rgba(0,0,0,1) 100%)"
      : "linear-gradient(to bottom, rgba(239,239,244,0) 0%, rgba(239,239,244,0.88) 45%, rgba(239,239,244,1) 100%)",
    pointerEvents: "none",
    zIndex: theme.zIndex.drawer + 1,
  },

  mobileBottomNavShellTelegram: {
    position: "fixed",
    left: 28,
    right: 28,
    bottom: "calc(24px + env(safe-area-inset-bottom, 0px))",
    zIndex: theme.zIndex.drawer + 3,
    background: theme.palette.type === "dark"
      ? "rgba(18, 18, 20, 0.04)"
      : "rgba(255, 255, 255, 0.04)",
    backdropFilter: "blur(28px) saturate(2)",
    WebkitBackdropFilter: "blur(28px) saturate(2)",
    borderRadius: 32,
    overflow: "hidden",
    border: `1px solid ${theme.palette.type === "dark" ? "rgba(255,255,255,0.14)" : "rgba(0,0,0,0.07)"}`,
    boxShadow: theme.palette.type === "dark"
      ? "0 8px 32px rgba(0,0,0,0.45)"
      : "0 6px 28px rgba(0,0,0,0.10)",
  },

  mobileBottomNavTelegram: {
    height: 64,
    background: "transparent",
    justifyContent: "center !important",
    "& .MuiBottomNavigationAction-root": {
      flex: "0 0 auto !important",
      minWidth: "0 !important",
      maxWidth: "none !important",
      width: "70px !important",
      padding: "8px 4px !important",
    },
    "& .MuiSvgIcon-root": {
      fontSize: "30px !important",
    },
    "& .MuiBottomNavigationAction-label": {
      fontSize: "10px !important",
      marginTop: "2px !important",
      opacity: "1 !important",
    },
  },

  mobileBottomNavActionTelegram: {
    flex: "0 0 auto !important",
    minWidth: "0 !important",
    maxWidth: "none !important",
    width: "70px !important",
    padding: "8px 4px !important",
    color: theme.palette.type === "dark" ? "rgba(235,235,245,0.75)" : "rgba(60,60,67,0.75)",
    "&.Mui-selected": {
      color: "#2AABEE",
      "& .MuiSvgIcon-root": {
        background: "rgba(42,171,238,0.18)",
        borderRadius: 18,
        padding: 5,
      },
    },
    "& .MuiBottomNavigationAction-wrapper": {
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: 2,
    },
    "& .MuiBottomNavigationAction-label": {
      fontSize: "10px !important",
      fontWeight: 500,
      marginTop: "2px !important",
      textTransform: "none",
      opacity: "1 !important",
      transition: "none !important",
    },
    "& .MuiBottomNavigationAction-label.Mui-selected": {
      fontSize: "10px !important",
      fontWeight: 700,
      color: "#2AABEE",
    },
    "& .MuiSvgIcon-root": {
      fontSize: "30px !important",
    },
  },

  telegramHeaderWrap: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    zIndex: theme.zIndex.drawer + 2,
    background: "transparent",
    paddingTop: "13px",
  },

  telegramHeaderRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    height: 44,
    paddingLeft: 16,
    paddingRight: 10,
  },

  telegramHeaderName: {
    fontSize: 17,
    fontWeight: 600,
    color: theme.palette.type === "dark" ? "#FFFFFF" : "#000000",
    letterSpacing: "-0.2px",
  },

  telegramComposeWrap: {
    position: "absolute",
    right: 10,
    top: "50%",
    transform: "translateY(-50%)",
    display: "flex",
    alignItems: "center",
  },

  telegramComposeBtn: {
    width: 34,
    height: 34,
    borderRadius: 10,
    border: "none",
    background: "transparent",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#3A9BFF",
    cursor: "pointer",
  },

  telegramSearchRow: {
    padding: "4px 24px 8px",
  },

  telegramSearchInput: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    background: theme.palette.type === "dark" ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.07)",
    borderRadius: 12,
    padding: "7px 12px",
    color: theme.palette.type === "dark" ? "rgba(235,235,245,0.45)" : "rgba(60,60,67,0.45)",
    fontSize: 15,
    cursor: "text",
  },

  mobileBottomNav: {
    height: 64,
    background: "transparent !important",
    backgroundColor: "transparent !important",
    paddingBottom: "env(safe-area-inset-bottom, 0px)",
  },

  mobileBottomNavAction: {
    minWidth: 0,
    color: theme.palette.text.secondary,
    "&.Mui-selected": {
      color: theme.palette.primary.main,
    },
    "& .MuiBottomNavigationAction-wrapper": {
      gap: theme.spacing(0.3),
    },
    "& .MuiBottomNavigationAction-label": {
      fontSize: 11,
      fontWeight: 600,
      marginTop: 0,
      textTransform: "none",
    },
    "& .MuiBottomNavigationAction-label.Mui-selected": {
      fontSize: 11,
    },
  },

  mobileBottomNavPrimaryAction: {
    "& .MuiSvgIcon-root": {
      fontSize: 30,
    },
  },

  desktopShellRail: {
    width: desktopShellRailWidth,
    minWidth: desktopShellRailWidth,
    flex: `0 0 ${desktopShellRailWidth}px`,
    display: "flex",
    flexDirection: "column",
    background:
      theme.mode === "light"
        ? "linear-gradient(180deg, #f3ecde 0%, #e6dfcf 100%)"
        : "linear-gradient(180deg, #111b21 0%, #0b141a 100%)",
    borderRight: `1px solid ${theme.palette.divider}`,
    boxShadow:
      theme.mode === "light"
        ? "4px 0 18px rgba(15, 23, 42, 0.08)"
        : "4px 0 18px rgba(0, 0, 0, 0.2)",
    position: "relative",
    zIndex: 2,
  },

  desktopShellRailSpacer: {
    minHeight: appBarHeight,
    flex: `0 0 ${appBarHeight}px`,
  },

  desktopShellRailContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing(1.25),
    padding: theme.spacing(1.5, 1.25, 1.75),
    height: "100%",
    overflowY: "auto",
    ...theme.scrollbarStylesSoft,
  },

  desktopShellBrand: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing(0.75),
    marginBottom: theme.spacing(0.5),
  },

  desktopShellBrandMark: {
    width: 34,
    height: 34,
    borderRadius: 12,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#fff",
    fontSize: 17,
    fontWeight: 800,
    letterSpacing: "0.04em",
    background:
      theme.mode === "light"
        ? "linear-gradient(135deg, #4c6a2d 0%, #738f45 100%)"
        : "linear-gradient(135deg, #128C7E 0%, #25D366 100%)",
    boxShadow:
      theme.mode === "light"
        ? "0 10px 24px rgba(85, 107, 47, 0.28)"
        : "0 10px 24px rgba(37, 211, 102, 0.28)",
  },

  desktopShellNavList: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(0.7),
  },

  desktopShellNavButton: {
    width: "100%",
    minHeight: 42,
    borderRadius: 13,
    padding: theme.spacing(0.5),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    border: `1px solid ${
      theme.mode === "light"
        ? "rgba(85, 107, 47, 0.12)"
        : "rgba(255, 255, 255, 0.06)"
    }`,
    background:
      theme.mode === "light"
        ? "rgba(255, 255, 255, 0.46)"
        : "rgba(255, 255, 255, 0.03)",
    color: theme.palette.text.secondary,
    textAlign: "center",
    transition: "all 0.22s ease",
    "& .MuiSvgIcon-root": {
      fontSize: 19,
    },
    "&:hover": {
      transform: "translateY(-1px)",
      color: theme.palette.primary.main,
      background:
        theme.mode === "light"
          ? "rgba(255, 255, 255, 0.9)"
          : "rgba(255, 255, 255, 0.07)",
      boxShadow:
        theme.mode === "light"
          ? "0 12px 22px rgba(15, 23, 42, 0.1)"
          : "0 12px 22px rgba(0, 0, 0, 0.3)",
    },
    "&.selected": {
      color: theme.mode === "light" ? theme.palette.primary.main : "#25D366",
      background:
        theme.mode === "light"
          ? "linear-gradient(180deg, rgba(255,255,255,0.96) 0%, rgba(236,244,223,0.96) 100%)"
          : "linear-gradient(180deg, rgba(37,211,102,0.22) 0%, rgba(37,211,102,0.1) 100%)",
      borderColor:
        theme.mode === "light"
          ? "rgba(85, 107, 47, 0.24)"
          : "rgba(37, 211, 102, 0.3)",
      boxShadow:
        theme.mode === "light"
          ? "0 16px 28px rgba(85, 107, 47, 0.14)"
          : "0 16px 28px rgba(0, 0, 0, 0.3)",
    },
  },

  desktopShellNavButtonPrimary: {
    background:
      theme.mode === "light"
        ? "linear-gradient(135deg, #4c6a2d 0%, #6f8a43 100%)"
        : "linear-gradient(135deg, #128C7E 0%, #25D366 100%)",
    color: "#fff",
    border: "none",
    boxShadow:
      theme.mode === "light"
        ? "0 14px 26px rgba(85, 107, 47, 0.28)"
        : "0 14px 26px rgba(37, 211, 102, 0.28)",
    "&:hover": {
      background:
        theme.mode === "light"
          ? "linear-gradient(135deg, #425d26 0%, #688342 100%)"
          : "linear-gradient(135deg, #0f6b5f 0%, #1fae57 100%)",
      color: "#fff",
    },
    "&.selected": {
      color: "#fff",
      background:
        theme.mode === "light"
          ? "linear-gradient(135deg, #425d26 0%, #688342 100%)"
          : "linear-gradient(135deg, #0f6b5f 0%, #1fae57 100%)",
    },
  },

  desktopToolsDrawerPaper: {
    top: appBarHeight,
    left: desktopShellRailWidth,
    height: `calc(100% - ${appBarHeight}px)`,
    width: 320,
    maxWidth: "calc(100vw - 140px)",
    borderTopRightRadius: 22,
    borderBottomRightRadius: 22,
    background: theme.palette.total,
    borderRight: `1px solid ${theme.palette.divider}`,
    boxShadow:
      theme.mode === "light"
        ? "10px 0 32px rgba(15, 23, 42, 0.14)"
        : "10px 0 32px rgba(0, 0, 0, 0.3)",
  },

  desktopToolsDrawerHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(1.5, 2, 1),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },

  desktopToolsDrawerList: {
    flex: 1,
    overflowY: "auto",
    ...theme.scrollbarStyles,
  },

  mobileToolsDrawerPaper: {
    borderTopLeftRadius: 22,
    borderTopRightRadius: 22,
    maxHeight: "78vh",
    overflow: "hidden",
    background: theme.palette.total,
  },

  mobileToolsHandle: {
    width: 46,
    height: 5,
    borderRadius: 999,
    background: theme.palette.divider,
    margin: "12px auto 6px",
  },

  mobileToolsHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(0.5, 2, 1.5),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },

  mobileToolsTitle: {
    fontSize: 16,
    fontWeight: 700,
    color: theme.palette.text.primary,
  },

  mobileToolsList: {
    maxHeight: "calc(78vh - 64px)",
    overflowY: "auto",
    paddingBottom: "calc(12px + env(safe-area-inset-bottom, 0px))",
    ...theme.scrollbarStyles,
  },

  mobileToolsQuickActions: {
    display: "grid",
    gridTemplateColumns: "1fr",
    gap: theme.spacing(1),
    padding: theme.spacing(1.25, 1.5, 0.75),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },

  mobileToolsQuickButton: {
    justifyContent: "flex-start",
    borderRadius: 12,
    padding: theme.spacing(1, 1.25),
    fontWeight: 700,
    textTransform: "none",
  },

  NotificationsPopOver: {
    // Mantém original
  },

  logo: {
    width: "100%",
    height: "45px",
    maxWidth: 180,
    [theme.breakpoints.down("sm")]: {
      width: "auto",
      height: "100%",
      maxWidth: 180,
    },
    logo: theme.logo,
    content:
      "url(" +
      (theme.mode === "light"
        ? theme.calculatedLogoLight()
        : theme.calculatedLogoDark()) +
      ")",
    transition: "all 0.3s ease", // Transição suave
    "&:hover": {
      transform: "scale(1.02)", // Pequeno zoom no hover
    },
  },

  hideLogo: {
    display: "none",
  },

  avatar2: {
    width: theme.spacing(4),
    height: theme.spacing(4),
    cursor: "pointer",
    borderRadius: "50%",
    border: "2px solid #ccc",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "scale(1.05)",
      borderColor: theme.palette.primary.main, // Usa cor do tema
    },
  },

  updateDiv: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },

  // Botões da toolbar melhorados
  toolbarButton: {
    color: "rgba(255, 255, 255, 0.9)",
    borderRadius: "8px",
    padding: "8px",
    margin: "0 2px",
    transition: "all 0.3s ease",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.1)",
      transform: "translateY(-1px)",
    },
    "&:active": {
      transform: "translateY(0)",
    },
  },

  // Menu hambúrguer com animação sutil
  menuButton: {
    color: "white",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.1)",
    },
    "& .MuiSvgIcon-root": {
      transition: "transform 0.3s ease",
    },
    "&:hover .MuiSvgIcon-root": {
      transform: "rotate(90deg)",
    },
  },

  // Seletor de idioma melhorado
  languageSelector: {
    position: "relative",
    display: "inline-block",
    "& > button": {
      background: "rgba(255, 255, 255, 0.1)",
      border: "none",
      borderRadius: "8px",
      color: "rgba(255, 255, 255, 0.9)",
      fontSize: "18px",
      padding: "8px 12px",
      cursor: "pointer",
      transition: "all 0.3s ease",
      "&:hover": {
        background: "rgba(255, 255, 255, 0.2)",
        transform: "translateY(-1px)",
      },
    },
    "& > div": {
      position: "absolute",
      top: "45px",
      left: "0",
      background: "#fff",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
      borderRadius: "8px",
      padding: "8px",
      zIndex: 1000,
      minWidth: "120px",
      "& button": {
        background: "none",
        border: "none",
        color: "#374151",
        display: "block",
        width: "100%",
        padding: "8px 12px",
        textAlign: "left",
        borderRadius: "6px",
        fontSize: "14px",
        fontWeight: 500,
        transition: "all 0.2s ease",
        "&:hover": {
          background: `${theme.palette.primary.main}10`, // Usa cor do tema
          color: theme.palette.primary.main, // Usa cor do tema
          transform: "none",
        },
      },
    },
  },

  // Badge animado
  animatedBadge: {
    "& .MuiBadge-badge": {
      animation: "$heartbeat 2s infinite",
    },
  },

  duePreviewSummaryWrap: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(170px, 1fr))",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1.5),
  },

  duePreviewSummaryCard: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 10,
    padding: theme.spacing(1),
    background: theme.mode === "dark" ? "rgba(255,255,255,0.04)" : "#f7f9fc",
  },

  duePreviewSectionTitle: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
    fontWeight: 700,
    fontSize: "0.95rem",
  },

  duePreviewList: {
    maxHeight: "180px",
    overflowY: "auto",
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 8,
    padding: theme.spacing(0.5),
    ...theme.scrollbarStyles,
  },

  duePreviewItem: {
    display: "grid",
    gridTemplateColumns: "1fr auto",
    gap: theme.spacing(1),
    padding: theme.spacing(0.8, 1),
    borderBottom: `1px solid ${theme.palette.divider}`,
    "&:last-child": {
      borderBottom: "none",
    },
  },

  "@keyframes heartbeat": {
    "0%": { transform: "scale(1)" },
    "14%": { transform: "scale(1.1)" },
    "28%": { transform: "scale(1)" },
    "42%": { transform: "scale(1.1)" },
    "70%": { transform: "scale(1)" },
  },
  "@keyframes fichasLivePulse": {
    "0%, 100%": { opacity: 1, transform: "scale(1)" },
    "50%": { opacity: 0.25, transform: "scale(0.78)" },
  },
  fichasLiveDot: {
    width: 5,
    height: 5,
    borderRadius: "50%",
    flex: "none",
    marginRight: 6,
    alignSelf: "center",
    background: "#25d366",
    boxShadow: "0 0 4px rgba(37,211,102,0.7)",
    animation: "$fichasLivePulse 1.7s ease-in-out infinite",
    "@media (prefers-reduced-motion: reduce)": { animation: "none" },
  },
}));

const GreenCountBadge = withStyles({
  badge: {
    backgroundColor: "#25d366",
    color: "#fff",
    fontSize: 10,
    minWidth: 16,
    height: 16,
    padding: "0 3px",
    fontWeight: 700,
  },
})(Badge);


const StyledBadge = withStyles((theme) => ({
  badge: {
    backgroundColor: "#44b700",
    color: "#44b700",
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      animation: "$ripple 1.2s infinite ease-in-out",
      border: "1px solid currentColor",
      content: '""',
    },
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(.8)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(2.4)",
      opacity: 0,
    },
  },
}))(Badge);

const formatPreviewCurrency = (valueCents) =>
  (Math.max(0, Number(valueCents || 0)) / 100).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const formatPreviewPhone = (value) => {
  const digits = String(value || "").replace(/\D/g, "");
  if (!digits) {
    return "-";
  }
  if (digits.length === 11) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
  }
  if (digits.length === 10) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
  }
  return digits;
};

// Faixa "Monitor de fichas" na barra do topo (só admin). Rótulo miúdo em cima
// do número: PGT. ▲ / +60D ▼ / QUIT 7D / SOLT 7D com N·C. Sem caixa/fundo — os
// números ficam direto na AppBar verde, então verde/vermelho são tons claros
// (senão some no verde). Todas as 4 colunas com a MESMA largura.
const FICHAS_MONITOR_GOOD = "#8FE9BE";
const FICHAS_MONITOR_BAD = "#FFA79B";
const FICHAS_MONITOR_CELL_W = 62;
const FichasMonitorMetric = ({ label, value, color, arrow, extra, first, onClick }) => (
  <div
    onClick={onClick}
    role={onClick ? "button" : undefined}
    tabIndex={onClick ? 0 : undefined}
    onKeyDown={onClick ? (e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); onClick(); } } : undefined}
    title={onClick ? "Ver detalhe" : undefined}
    style={{
      cursor: onClick ? "pointer" : "default",
      flex: "none",
      minWidth: FICHAS_MONITOR_CELL_W,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: "0 11px",
      borderLeft: first ? "none" : "1px solid rgba(255,255,255,0.22)",
      whiteSpace: "nowrap"
    }}
  >
    <span
      style={{
        fontFamily: "monospace",
        fontSize: 8,
        fontWeight: 700,
        textTransform: "uppercase",
        letterSpacing: ".04em",
        color: "rgba(255,255,255,0.72)",
        lineHeight: 1
      }}
    >
      {label}
    </span>
    <span style={{ display: "flex", alignItems: "baseline", gap: 3, marginTop: 2 }}>
      {arrow ? (
        <span style={{ fontSize: 8, color: color || "#fff" }}>{arrow}</span>
      ) : null}
      <span
        style={{
          fontWeight: 700,
          fontSize: 15,
          letterSpacing: "-.01em",
          color: color || "#fff",
          lineHeight: 1
        }}
      >
        {value}
      </span>
      {extra || null}
    </span>
  </div>
);

const FichasMonitorStrip = ({ data, dotClass, onOpenDetail }) => {
  if (!data) return null;
  const novos = Number(data.soltesNovos || 0);
  const clientes = Number(data.soltesClientes || 0);
  const soltesTotal = novos + clientes;
  // divisão novo/cliente: texto pequeno na mesma linha de base do número, com
  // uma barra separando. Sem empilhar, sem subir o número.
  const ncInline = (
    <span
      style={{
        fontFamily: "monospace",
        fontSize: 8,
        fontWeight: 700,
        letterSpacing: ".02em",
        color: "rgba(255,255,255,0.7)",
        marginLeft: 4
      }}
    >
      {novos}N<span style={{ opacity: 0.55, margin: "0 1px" }}>/</span>
      {clientes}C
    </span>
  );
  return (
    <div
      title="Monitor de fichas — atualiza em tempo real"
      style={{
        display: "flex",
        alignItems: "center",
        marginRight: 12,
        flex: "none"
      }}
    >
      {dotClass ? <span className={dotClass} title="ao vivo" /> : null}
      <FichasMonitorMetric
        first
        label="PGT."
        arrow="▲"
        color={FICHAS_MONITOR_GOOD}
        value={data.pagantes}
        onClick={onOpenDetail ? () => onOpenDetail("pgt") : undefined}
      />
      <FichasMonitorMetric
        label="+60D"
        arrow="▼"
        color={FICHAS_MONITOR_BAD}
        value={data.atraso60}
        onClick={onOpenDetail ? () => onOpenDetail("d60") : undefined}
      />
      <FichasMonitorMetric label="QUIT 7D" value={data.quitadosSemana} />
      <FichasMonitorMetric label="SOLT 7D" value={soltesTotal} extra={ncInline} />
    </div>
  );
};

const LoggedInLayout = ({ children, hideMenu = false }) => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const mainContentRef = useRef(null);
  const mainScrollPositionsRef = useRef(readMainScrollStorage());
  const [userModalOpen, setUserModalOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [fontScale, setFontScale] = useState(() => {
    const saved = localStorage.getItem("layout.fontScale");
    return saved ? Number(saved) : 100;
  });
  const [fontPopoverAnchor, setFontPopoverAnchor] = useState(null);
  const [routeMarkedCount, setRouteMarkedCount] = useState(0);
  const [pixSheetsPending, setPixSheetsPending] = useState(0);
  const [pixSheetOpen, setPixSheetOpen] = useState(false);
  const [solteSheetRegiao, setSolteSheetRegiao] = useState(null);
  const [soltePendingCapital, setSoltePendingCapital] = useState(0);
  const [fichasMonitor, setFichasMonitor] = useState(null);
  const [fichasDetailKind, setFichasDetailKind] = useState(null);
  const { handleLogout, loading, user, socket } = useContext(AuthContext);

  // Biometric login state
  const [biometricEnabled, setBiometricEnabled] = useState(false);
  const [biometricDialogOpen, setBiometricDialogOpen] = useState(false);
  const [biometricPassword, setBiometricPassword] = useState("");
  const [biometricLoading, setBiometricLoading] = useState(false);
  const [biometryType, setBiometryType] = useState(0);

  useEffect(() => {
    if (!isEquipeChatMobileApp()) return;
    loadBiometricCredentials().then(creds => setBiometricEnabled(!!creds));
    getBiometryInfo().then(({ biometryType: t }) => setBiometryType(t));
  }, []);

  // Web push notifications state (PWA only, not APK)
  const showNotifToggle = isWebPushSupported() && !isEquipeChatMobileApp();
  const [notifEnabled, setNotifEnabled] = useState(false);
  const [notifLoading, setNotifLoading] = useState(false);

  useEffect(() => {
    if (!showNotifToggle) return;
    setNotifEnabled(getWebPushPermission() === "granted");
  }, [showNotifToggle]);
  const { whatsApps } = useContext(WhatsAppsContext);
  const [motoboyUsers, setMotoboyUsers] = useState([]);

  // Chip ordering (persisted)
  const [chipOrder, setChipOrder] = useState(() => {
    try { return JSON.parse(localStorage.getItem("motoboyChipOrder") || "[]"); } catch { return []; }
  });
  const dragChipIdx = useRef(null);

  // Chip context menu
  const [chipContextMenu, setChipContextMenu] = useState(null);
  const [chipActionLoading, setChipActionLoading] = useState(false);

  // Contagem de conversas não respondidas (badge do botão Conversas)
  const [unreadConversationCount, setUnreadConversationCount] = useState(0);
  const unreadTicketIdsRef = useRef(new Set());

  useEffect(() => {
    if (!user?.id) return;
    api.get("/tickets", { params: { withUnreadMessages: "true", pageNumber: 1 } })
      .then(({ data }) => {
        const ids = new Set((data.tickets || []).map(t => Number(t.id)));
        unreadTicketIdsRef.current = ids;
        setUnreadConversationCount(data.count || 0);
      })
      .catch(() => {});
  }, [user?.id]);

  // Cache offline das fichas de cadastro (ver utils/registrationsCache.js) —
  // baixa todas as fichas da empresa em segundo plano assim que loga (e
  // depois de tempos em tempos), pra abrir a aba Cadastro mesmo sem
  // internet, sem precisar já ter aberto aquela ficha antes.
  useEffect(() => {
    if (!user?.id) return;
    startRegistrationsAutoSync();
  }, [user?.id]);

  useEffect(() => {
    if (!user?.id || !socket) return;
    const companyId = user.companyId;

    const onTicketEvent = (data) => {
      if (data.action === "updateUnread" || data.action === "delete") {
        const id = Number(data.ticketId || 0);
        if (id && unreadTicketIdsRef.current.has(id)) {
          unreadTicketIdsRef.current.delete(id);
          setUnreadConversationCount(prev => Math.max(0, prev - 1));
        }
      }
    };

    const onMessageEvent = (data) => {
      if (data.action === "create" && !data.message?.fromMe && !data.message?.read) {
        const id = Number(data.ticket?.id || data.message?.ticketId || 0);
        if (id && !unreadTicketIdsRef.current.has(id)) {
          unreadTicketIdsRef.current.add(id);
          setUnreadConversationCount(prev => prev + 1);
        }
      }

      // Guarda no cache local pra SEMPRE, mesmo de tickets fechados agora —
      // ouvido aqui (componente sempre montado) em vez de dentro do MessagesList
      // (só existe pro ticket aberto no momento) pra qualquer conversa reabrir
      // instantânea depois, não só a que estava na tela quando a mensagem chegou.
      //
      // SÓ mescla se já existe cache pra esse ticket (conversa já aberta
      // antes nesse navegador). Bug real corrigido 13/08/2026: criar um
      // cache NOVO aqui a partir de 1 mensagem avulsa "envenenava" a conversa
      // inteira — a próxima abertura via afterId ancorava nesse único id
      // (bem recente) e nunca mais buscava o histórico de verdade que já
      // existia no banco (visto no grupo "Extrato Ativo Pay" logo após a
      // importação do histórico: só a mensagem mais nova aparecia). Sem
      // cache aqui, a próxima abertura real faz um pageNumber=1 limpo, que
      // acerta o hasMore direito.
      if (data.action === "create" && data.message) {
        const ticketId = data.message.ticketId || data.ticket?.id;
        if (ticketId) {
          getCachedTicketMessages(ticketId).then((existing) => {
            if (existing?.messages?.length) {
              mergeCachedTicketMessages(ticketId, [data.message]);
            }
          });
        }
      }

      // Mesma lógica acima, mas pra mensagem que já existia e só teve o
      // conteúdo atualizado (ex: "Dar Baixa" clicado — dataJson zerado,
      // corpo ganha "🔒 Baixa dada..."). Bug real corrigido 13/08/2026: como
      // só "create" mexia no cache, uma conversa como a "Extrato Ativo Pay"
      // (reaberta sem passar por aqui de novo, só lendo o cache local) podia
      // continuar mostrando pra sempre o botão "Dar Baixa" de uma mensagem
      // já baixada em outro dispositivo/aba — clicar nele então batia no
      // backend com o dataJson já nulo e dava "Essa mensagem não tem uma
      // baixa pendente", mesmo a baixa já tendo sido registrada certa.
      if (data.action === "update" && data.message) {
        const ticketId = data.message.ticketId || data.ticket?.id;
        if (ticketId) {
          getCachedTicketMessages(ticketId).then((existing) => {
            if (existing?.messages?.length) {
              mergeCachedTicketMessages(ticketId, [data.message]);
            }
          });
        }
      }
    };

    socket.on(`company-${companyId}-ticket`, onTicketEvent);
    socket.on(`company-${companyId}-appMessage`, onMessageEvent);

    return () => {
      socket.off(`company-${companyId}-ticket`, onTicketEvent);
      socket.off(`company-${companyId}-appMessage`, onMessageEvent);
    };
  }, [user?.id, user?.companyId, socket]);

  // Monitor de fichas (faixa fixa na barra do topo) — SÓ admin (Patrick /
  // Helen / Ricardo). Motoboy (profile "user") não vê. Busca 1x + tempo real
  // via socket "company-<id>-fichas-monitor".
  useEffect(() => {
    if (user?.profile !== "admin") {
      setFichasMonitor(null);
      return undefined;
    }
    const companyId = user?.companyId;
    let alive = true;
    const buscar = () =>
      api
        .get("/contact-registrations/monitor")
        .then(({ data }) => {
          if (alive) setFichasMonitor(data);
        })
        .catch(() => {});
    buscar();
    // 24/10/2026: sempre igual pra todos os admins - além do tempo real, busca
    // de novo a cada 1 min e quando a janela volta pro primeiro plano (aba em
    // 2º plano / computador dormindo perdia a atualização da virada do dia).
    const timer = setInterval(() => { if (document.visibilityState === "visible") buscar(); }, 60 * 1000);
    const onVis = () => { if (document.visibilityState === "visible") buscar(); };
    document.addEventListener("visibilitychange", onVis);

    const onMonitor = (snapshot) => setFichasMonitor(snapshot);
    if (socket && companyId) socket.on(`company-${companyId}-fichas-monitor`, onMonitor);
    return () => {
      alive = false;
      clearInterval(timer);
      document.removeEventListener("visibilitychange", onVis);
      if (socket && companyId) socket.off(`company-${companyId}-fichas-monitor`, onMonitor);
    };
  }, [user?.profile, user?.companyId, socket]);

  // Carrega funcionários e mantém status online em tempo real via socket
  useEffect(() => {
    document.documentElement.style.fontSize = `${fontScale}%`;
    localStorage.setItem("layout.fontScale", String(fontScale));
  }, [fontScale]);

  useEffect(() => {
    if (user?.profile !== "admin") return;

    // Estado inicial: usa campo online da API (DB) e atualiza por socket
    api.get("/users").then(({ data }) => {
      setMotoboyUsers((data.users || []).filter(u => u.restrictedToWhatsappId));
    }).catch(() => {});

    if (!socket) return;

    // Atualiza nome/dados quando usuário é editado
    const userUpdateHandler = (data) => {
      if (data.action === "update" && data.user) {
        setMotoboyUsers(prev =>
          prev.map(u => u.id === data.user.id ? { ...u, ...data.user } : u)
        );
      }
    };

    // Marca online quando heartbeat chega
    const onlineHandler = ({ userId }) => {
      setMotoboyUsers(prev =>
        prev.map(u => u.id === userId ? { ...u, online: true } : u)
      );
    };

    // Marca offline quando timeout do heartbeat dispara
    const offlineHandler = ({ userId }) => {
      setMotoboyUsers(prev =>
        prev.map(u => u.id === userId ? { ...u, online: false } : u)
      );
    };

    // Lista inicial de quem está online agora (enviado pelo server na conexão)
    const usersOnlineHandler = (users) => {
      const onlineIds = new Set((users || []).map(u => Number(u.id)));
      setMotoboyUsers(prev =>
        prev.map(u => ({ ...u, online: onlineIds.has(u.id) }))
      );
    };

    // Novo usuário conectou
    const userNewHandler = ({ user: newUser }) => {
      setMotoboyUsers(prev =>
        prev.map(u => u.id === newUser?.id ? { ...u, online: true } : u)
      );
    };

    // Pede ao server a lista atual de online imediatamente
    socket.emit("heartbeat");

    socket.on(`company-${user.companyId}-user`, userUpdateHandler);
    socket.on("user:online", onlineHandler);
    socket.on("user:offline", offlineHandler);
    socket.on("users:online", usersOnlineHandler);
    socket.on("user:new", userNewHandler);

    return () => {
      socket.off(`company-${user.companyId}-user`, userUpdateHandler);
      socket.off("user:online", onlineHandler);
      socket.off("user:offline", offlineHandler);
      socket.off("users:online", usersOnlineHandler);
      socket.off("user:new", userNewHandler);
    };
  }, [user?.profile, user?.companyId, socket]);

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerVariant, setDrawerVariant] = useState("permanent");

  const [showAnnouncementsModal, setShowAnnouncementsModal] = useState(false);
  const [announcements, setAnnouncements] = useState([]);
  const [selectedAnnouncement, setSelectedAnnouncement] = useState(null);
  const [showBirthdayModal, setShowBirthdayModal] = useState(false);
  const [duePreviewOpen, setDuePreviewOpen] = useState(false);
  const [duePreviewData, setDuePreviewData] = useState(null);
  const [mobileToolsOpen, setMobileToolsOpen] = useState(false);
  const [newTicketModalOpen, setNewTicketModalOpen] = useState(false);
  const [composeMenuAnchor, setComposeMenuAnchor] = useState(null);
  const [newTicketInitialNumber, setNewTicketInitialNumber] = useState(null);
  const checkoutToastRef = useRef({
    transactionId: "",
    at: 0
  });

  const theme = useTheme();
  const isDesktopShellApp = isEquipeChatDesktopShell();
  const isStandalonePwa = useIsStandalonePwa();
  const isDesktopAppLayout = useIsDesktopAppLayout();
  const isSmallUp = useMediaQuery(theme.breakpoints.up("sm"));
  const isSmallDown = useMediaQuery(theme.breakpoints.down("sm"));
  const greaterThenSm = isSmallUp || isDesktopAppLayout;
  const isMobile = !isDesktopAppLayout && (isStandalonePwa || isSmallDown);
  const isXaiLeadUser = isXaiLeadProfile(user);
  const [telegramEditMode, setTelegramEditModeState] = useState(false);
  const [telegramSelectedCount, setTelegramSelectedCount] = useState(0);
  const [showTelegramSearch, setShowTelegramSearch] = useState(true);

  useEffect(() => {
    if (!isEquipeChatMobileApp()) return;
    const handler = (e) => {
      setTelegramEditModeState(e.detail?.editMode ?? false);
      setTelegramSelectedCount(0);
    };
    const selHandler = (e) => {
      setTelegramSelectedCount((e.detail?.selected || []).length);
    };
    const scrollHandler = (e) => {
      setShowTelegramSearch(e.detail?.isAtTop ?? true);
    };
    window.addEventListener("telegram-edit-mode", handler);
    window.addEventListener("telegram-selection", selHandler);
    window.addEventListener("telegram-list-scroll-top", scrollHandler);
    return () => {
      window.removeEventListener("telegram-edit-mode", handler);
      window.removeEventListener("telegram-selection", selHandler);
      window.removeEventListener("telegram-list-scroll-top", scrollHandler);
    };
  }, []);

  const pathSegments = location.pathname.split("/").filter(Boolean);
  const isTicketConversation =
    pathSegments[0] === "tickets" &&
    Boolean(pathSegments[1] && pathSegments[1] !== "undefined");
  const hideConversationTopShortcuts =
    isMobile && isTicketConversation;
  const isRestrictedUser = Boolean(user?.restrictedToWhatsappId);
  const showMobileBottomNavigation =
    isMobile && !hideMenu && !isTicketConversation &&
    !isXaiLeadUser &&
    !location.pathname.startsWith("/cadastro") &&
    (!isRestrictedUser || isEquipeChatMobileApp()) &&
    !(isEquipeChatMobileApp() && isRestrictedUser && !user?.allowBillingMobile);
  const showDesktopShellRail =
    isDesktopAppLayout && !isMobile && !hideMenu;

  const [profileUrl, setProfileUrl] = useState(null);

  useEffect(() => {
    const fetchAnnouncements = async () => {
      try {
        const { data } = await api.get("/announcements/for-company", {
          params: {
            status: true,
            pageNumber: "1"
          }
        });

        // Filtra apenas os informativos ativos e não expirados
        const activeAnnouncements = data.records.filter(announcement => {
          const isActive = announcement.status === true || announcement.status === "true";
          const isNotExpired = !announcement.expiresAt || new Date(announcement.expiresAt) > new Date();
          return isActive && isNotExpired;
        });

        setAnnouncements(activeAnnouncements);

        // Mostra o modal apenas se houver informativos ativos
        if (activeAnnouncements.length > 0) {
          setShowAnnouncementsModal(true);
        }
      } catch (err) {
        toastError(err);
      }
    };

    if (user?.id) {
      fetchAnnouncements();
    }
  }, [user?.id]);

  useEffect(() => {
    if (isMobile) {
      setDrawerOpen(false);
    } else if (user.defaultMenu === "closed") {
      setDrawerOpen(false);
    } else {
      setDrawerOpen(true);
    }
  }, [user.defaultMenu, isMobile]);

  useEffect(() => {
    setDrawerVariant(isMobile ? "temporary" : "permanent");
  }, [isMobile]);

  useEffect(() => {
    if (hideConversationTopShortcuts) {
      setDrawerOpen(false);
      setMobileToolsOpen(false);
    }
  }, [hideConversationTopShortcuts]);

  useEffect(() => {
    setMobileToolsOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const companyId = user?.companyId;

    if (companyId) {
      const buildProfileUrl = () => {
        const savedProfileImage = localStorage.getItem("profileImage");
        const currentProfileImage = savedProfileImage || user.profileImage;

        if (currentProfileImage) {
          return `${backendUrl}/public/company${companyId}/user/${currentProfileImage}`;
        }
        return `${backendUrl}/public/app/noimage.png`;
      };

      setProfileUrl(buildProfileUrl());
    }
  }, [user?.companyId, user?.profileImage, backendUrl]);

  // Callbacks dos eventos
  const handleAuthEvent = useCallback((data) => {
    if (data.user.id === +user?.id) {
      toastError("Sua conta foi acessada em outro computador.");
      setTimeout(() => {
        localStorage.clear();
        window.location.reload();
      }, 1000);
    }
  }, [user?.id]);

  const handleUserUpdate = useCallback((data) => {
    if (data.action === "update" && data.user.id === +user?.id) {
      if (data.user.profileImage) {
        const newProfileUrl = `${backendUrl}/public/company${user?.companyId}/user/${data.user.profileImage}`;
        setProfileUrl(newProfileUrl);
        localStorage.setItem("profileImage", data.user.profileImage);
      }
    }
  }, [user?.companyId, user?.id, backendUrl]);

  // Callbacks para eventos de aniversário
  const handleUserBirthday = useCallback((data) => {
    console.log("🎂 Evento de aniversário de usuário recebido:", data);
    if (data.userId === +user?.id) {
      setShowBirthdayModal(true);
    }
  }, [user?.id]);

  const handleContactBirthday = useCallback((data) => {
    console.log("🎂 Evento de aniversário de contato recebido:", data);
    // Para contatos, apenas logamos por enquanto
    // A mensagem já foi enviada automaticamente pelo backend
  }, []);

  const handleRegistrationDuePreview = useCallback((data) => {
    if (!data || typeof data !== "object") {
      return;
    }
    const companyId = Number(user?.companyId || 0);
    const generatedAt = String(data?.generatedAt || "");
    const saved = readDuePreviewStorage(companyId);

    // Se o usuario ja clicou "Entendi" para esse mesmo preview, nao reabrir.
    if (
      saved?.dismissed &&
      saved?.generatedAt &&
      saved.generatedAt === generatedAt
    ) {
      setDuePreviewData(data);
      return;
    }

    setDuePreviewData(data);
    setDuePreviewOpen(true);
    writeDuePreviewStorage(companyId, {
      data,
      dismissed: false,
      generatedAt
    });
  }, [user?.companyId]);

  const handleDuePreviewAcknowledge = useCallback(() => {
    const companyId = Number(user?.companyId || 0);
    const generatedAt = String(duePreviewData?.generatedAt || "");

    writeDuePreviewStorage(companyId, {
      data: duePreviewData || null,
      dismissed: true,
      generatedAt
    });

    setDuePreviewOpen(false);
  }, [duePreviewData, user?.companyId]);

  useEffect(() => {
    const companyId = Number(user?.companyId || 0);
    if (!companyId) {
      return;
    }

    const saved = readDuePreviewStorage(companyId);
    if (!saved?.data) {
      return;
    }

    setDuePreviewData(saved.data);
    if (!saved.dismissed) {
      setDuePreviewOpen(true);
    }
  }, [user?.companyId]);

  const handleCheckoutPaymentSettled = useCallback((payload = {}) => {
    if (isXaiLeadUser) {
      return;
    }

    const transactionId = String(payload?.transactionId || "").trim();
    const amountCents = Math.max(0, Math.round(Number(payload?.amountCents || 0)));
    const payerName = String(payload?.payerName || "Cliente").trim() || "Cliente";
    const now = Date.now();

    if (
      transactionId &&
      checkoutToastRef.current.transactionId === transactionId &&
      now - Number(checkoutToastRef.current.at || 0) < 15000
    ) {
      return;
    }

    checkoutToastRef.current = {
      transactionId,
      at: now
    };

    toast.success(
      `Pagamento confirmado no checkout: ${payerName} (${formatPreviewCurrency(amountCents)})`,
      {
        autoClose: 6000
      }
    );
  }, [isXaiLeadUser]);

  // Verificar aniversários no login
  const checkBirthdaysOnLogin = useCallback(async () => {
    if (user?.id && user?.companyId) {
      try {
        const { data } = await api.get("/birthdays/today");
        const birthdayData = data.data;

        // Verificar se o usuário atual faz aniversário hoje
        const userBirthday = birthdayData.users.find(u => u.id === +user.id);
        if (userBirthday) {
          console.log("🎂 Usuário faz aniversário hoje! Mostrando modal...");
          setShowBirthdayModal(true);
        }

        // Se há aniversariantes, mostrar notificação
        if (birthdayData.users.length > 0 || birthdayData.contacts.length > 0) {
          console.log("🎂 Há aniversariantes hoje:", birthdayData);
        }
      } catch (error) {
        console.error("Erro ao verificar aniversários:", error);
      }
    }
  }, [user?.id, user?.companyId]);

  // Registrar listeners
  useSocketListener(socket, user, 'auth', handleAuthEvent);
  useSocketListener(socket, user, 'user', handleUserUpdate);
  useSocketListener(socket, user, 'user-birthday', handleUserBirthday);
  useSocketListener(socket, user, 'contact-birthday', handleContactBirthday);
  useSocketListener(socket, user, 'registration-due-preview', handleRegistrationDuePreview);
  useSocketListener(
    socket,
    user,
    "checkout-payment-settled",
    handleCheckoutPaymentSettled
  );

  // Verificar aniversários quando o usuário faz login
  useEffect(() => {
    if (user?.id && user?.companyId) {
      // Pequeno delay para garantir que o socket esteja conectado
      const timer = setTimeout(() => {
        checkBirthdaysOnLogin();
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [user?.id, user?.companyId, checkBirthdaysOnLogin]);

  // Status do usuário
  useEffect(() => {
    if (socket?.emit && user?.companyId) {
      socket.emit("userStatus");

      const interval = setInterval(() => {
        socket?.emit && socket.emit("userStatus");
      }, 1000 * 60 * 5);

      return () => clearInterval(interval);
    }
  }, [socket, user?.companyId]);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
    setMenuOpen(true);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setMenuOpen(false);
  };

  const handleOpenUserModal = () => {
    setUserModalOpen(true);
    handleCloseMenu();
  };

  const handleClickLogout = () => {
    handleCloseMenu();
    handleLogout();
  };

  const handleBiometricToggle = async () => {
    handleCloseMenu();
    const bioLabel = getBiometryLabel(biometryType);
    if (biometricEnabled) {
      await clearBiometricCredentials();
      setBiometricEnabled(false);
      toast.success(`Login com ${bioLabel} desativado.`);
    } else {
      // Verificar disponibilidade em tempo real (plugin pode não estar no IPA atual)
      const { available, biometryType: bType } = await getBiometryInfo();
      setBiometryType(bType);
      if (!available) {
        toast.warning(
          "Biometria não disponível. Verifique se o Face ID está configurado nas configurações do iPhone e se esta versão do app suporta o recurso.",
          { autoClose: 5000 }
        );
        return;
      }
      setBiometricPassword("");
      setBiometricDialogOpen(true);
    }
  };

  const handleBiometricSave = async () => {
    if (!biometricPassword.trim()) {
      toast.warning("Informe sua senha.");
      return;
    }
    setBiometricLoading(true);
    const bioLabel = getBiometryLabel(biometryType);
    try {
      const ok = await authenticateWithBiometric();
      if (!ok) { toast.error(`Verificação de ${bioLabel} falhou.`); return; }
      await saveBiometricCredentials(user.email, biometricPassword);
      setBiometricEnabled(true);
      setBiometricDialogOpen(false);
      toast.success(`Login com ${bioLabel} ativado!`);
    } finally {
      setBiometricLoading(false);
      setBiometricPassword("");
    }
  };

  const handleNotifToggle = async () => {
    handleCloseMenu();
    if (notifEnabled) {
      setNotifLoading(true);
      try {
        await unsubscribeWebPush();
        setNotifEnabled(false);
        toast.success("Notificações desativadas.");
      } finally {
        setNotifLoading(false);
      }
    } else {
      setNotifLoading(true);
      try {
        const permission = getWebPushPermission();
        if (permission === "denied") {
          toast.warning("Permissão de notificação bloqueada. Habilite nas configurações do navegador.");
          return;
        }
        if (permission === "default") {
          const granted = await requestWebPushPermission();
          if (!granted) {
            toast.warning("Permissão de notificação negada.");
            return;
          }
        }
        const ok = await subscribeWebPush();
        if (ok) {
          setNotifEnabled(true);
          toast.success("Notificações ativadas!");
        } else {
          toast.error("Não foi possível ativar. Verifique se o app está instalado como PWA.");
        }
      } catch (err) {
        console.error("[Notif] Erro:", err);
        toast.error("Erro: " + (err?.message || "Falha ao registrar notificação."));
      } finally {
        setNotifLoading(false);
      }
    }
  };

  const drawerClose = () => {
    setMobileToolsOpen(false);
    if (isMobile || user.defaultMenu === "closed") {
      setDrawerOpen(false);
    }
  };

  const handleCloseMobileTools = useCallback(() => {
    setMobileToolsOpen(false);
  }, []);

  const handleMobileNavigation = useCallback((event, value) => {
    if (value === "tickets") {
      setMobileToolsOpen(false);
      history.push("/tickets");
      return;
    }

    if (value === "registrations") {
      setMobileToolsOpen(false);
      history.push("/registrations");
      return;
    }

    if (value === "billing") {
      setMobileToolsOpen(false);
      history.push("/registrations-billing");
      return;
    }

    if (value === "new-ticket") {
      setMobileToolsOpen(false);
      setNewTicketModalOpen(true);
      return;
    }

    if (value === "tools") {
      setMobileToolsOpen(true);
      return;
    }

    if (value === "count") {
      setMobileToolsOpen(false);
      history.push("/registrations-count");
      return;
    }

    if (value === "lead1") {
      setMobileToolsOpen(false);
      history.push("/leads");
      return;
    }

    if (value === "visitas") {
      setMobileToolsOpen(false);
      history.push("/visitas");
      return;
    }

    if (value === "clientes-app") {
      setMobileToolsOpen(false);
      history.push("/clientes-app");
      return;
    }

    if (value === "motoboys") {
      setMobileToolsOpen(false);
      history.push("/motoboys");
      return;
    }

    if (value === LEAD_ROUTE_CONFIG.xai.navValue) {
      setMobileToolsOpen(false);
      history.push(LEAD_ROUTE_CONFIG.xai.path);
      return;
    }

    if (value === LEAD_ROUTE_CONFIG.rafaelle.navValue) {
      setMobileToolsOpen(false);
      history.push(LEAD_ROUTE_CONFIG.rafaelle.path);
      return;
    }

    if (value === LEAD_ROUTE_CONFIG.marcella.navValue) {
      setMobileToolsOpen(false);
      history.push(LEAD_ROUTE_CONFIG.marcella.path);
      return;
    }

    if (value === "couriers") {
      setMobileToolsOpen(false);
      history.push("/couriers");
      return;
    }

    if (value === "search") {
      setMobileToolsOpen(false);
      history.push("/tickets");
      setTimeout(() => {
        const searchInput = document.querySelector("input[placeholder*='Buscar'], input[placeholder*='buscar'], input[placeholder*='Pesquisar'], input[type='search']");
        if (searchInput) searchInput.focus();
      }, 300);
      return;
    }

  }, [history]);

  const handleCloseMobileNewTicket = useCallback((ticket) => {
    setNewTicketModalOpen(false);
    setNewTicketInitialNumber(null);

    if (ticket?.uuid) {
      history.push(`/tickets/${ticket.uuid}`);
    }
  }, [history]);

  useEffect(() => {
    const handler = (e) => {
      setNewTicketInitialNumber(e.detail?.number || null);
      setNewTicketModalOpen(true);
    };
    window.addEventListener("open-new-ticket-with-number", handler);
    return () => window.removeEventListener("open-new-ticket-with-number", handler);
  }, []);

  const mobileNavigationValue = useMemo(() => {
    if (mobileToolsOpen) {
      return "tools";
    }

    if (location.pathname.startsWith("/registrations-count")) {
      return "count";
    }

    if (location.pathname.startsWith("/registrations-billing")) {
      return "billing";
    }

    if (location.pathname.startsWith("/registrations")) {
      return "registrations";
    }

    if (location.pathname.startsWith("/tickets")) {
      return "tickets";
    }

    return false;
  }, [location.pathname, mobileToolsOpen]);

  const desktopShellNavigationValue = useMemo(() => {
    if (location.pathname.startsWith("/registrations-count")) {
      return "count";
    }

    if (
      location.pathname === "/visitas" ||
      location.pathname.startsWith("/visitas/")
    ) {
      return "visitas";
    }

    if (
      location.pathname === "/motoboys" ||
      location.pathname.startsWith("/motoboys/")
    ) {
      return "motoboys";
    }

    if (
      location.pathname === LEAD_ROUTE_CONFIG.xai.path ||
      location.pathname.startsWith(`${LEAD_ROUTE_CONFIG.xai.path}/`)
    ) {
      return LEAD_ROUTE_CONFIG.xai.navValue;
    }

    if (
      location.pathname === LEAD_ROUTE_CONFIG.rafaelle.path ||
      location.pathname.startsWith(`${LEAD_ROUTE_CONFIG.rafaelle.path}/`)
    ) {
      return LEAD_ROUTE_CONFIG.rafaelle.navValue;
    }

    if (
      location.pathname === LEAD_ROUTE_CONFIG.marcella.path ||
      location.pathname.startsWith(`${LEAD_ROUTE_CONFIG.marcella.path}/`) ||
      location.pathname === "/leads2" ||
      location.pathname.startsWith("/leads2/")
    ) {
      return LEAD_ROUTE_CONFIG.marcella.navValue;
    }

    if (mobileToolsOpen) {
      return "tools";
    }

    if (location.pathname.startsWith("/registrations-billing")) {
      return "billing";
    }

    if (location.pathname.startsWith("/registrations")) {
      return "registrations";
    }

    if (location.pathname.startsWith("/tickets")) {
      return "tickets";
    }

    return false;
  }, [location.pathname, mobileToolsOpen]);

  const isRegistrationsPage = location.pathname.startsWith("/registrations") || location.pathname.startsWith("/cadastro");

  const loadRouteMarkedCount = useCallback(async () => {
    try {
      const { data } = await api.get("/contact-registrations/route-marks");
      const marks =
        data?.marks && typeof data.marks === "object" && !Array.isArray(data.marks)
          ? data.marks
          : {};
      const now = Date.now();
      const count = Object.values(marks).filter((mark) => {
        const expiresAt = typeof mark === "object" ? Number(mark?.expiresAt) : Number(mark);
        return Number.isFinite(expiresAt) && expiresAt > now;
      }).length;
      setRouteMarkedCount(count);
    } catch (_error) {
      setRouteMarkedCount(0);
    }
  }, []);

  useEffect(() => {
    if (!user?.id) {
      return undefined;
    }
    loadRouteMarkedCount();
    const interval = setInterval(loadRouteMarkedCount, 60000);
    return () => clearInterval(interval);
  }, [user?.id, location.pathname, loadRouteMarkedCount]);

  const loadPixSheetsPending = useCallback(async () => {
    try {
      const { data } = await api.get("/pix-sheets");
      setPixSheetsPending(Number(data?.pendentes) || 0);
    } catch (_error) {
      setPixSheetsPending(0);
    }
  }, []);

  useEffect(() => {
    if (!user?.id) {
      return undefined;
    }
    loadPixSheetsPending();
    const interval = setInterval(loadPixSheetsPending, 60000);
    return () => clearInterval(interval);
  }, [user?.id, location.pathname, loadPixSheetsPending]);

  const loadSoltePending = useCallback(async () => {
    try {
      const [interior, capital] = await Promise.all([
        api.get("/solte-sheets/interior"),
        api.get("/solte-sheets/capital")
      ]);
      setSoltePendingCapital(Number(capital?.data?.pendentes) || 0);
    } catch (_error) {
      setSoltePendingCapital(0);
    }
  }, []);

  useEffect(() => {
    if (!user?.id) {
      return undefined;
    }
    loadSoltePending();
    const interval = setInterval(loadSoltePending, 60000);
    return () => clearInterval(interval);
  }, [user?.id, location.pathname, loadSoltePending]);

  const handleOpenRouteSheet = () => {
    if (isRegistrationsPage) {
      window.dispatchEvent(new CustomEvent("agilzap:open-route-sheet"));
    } else {
      history.push("/cadastro?openRouteSheet=1");
    }
  };
  const handleOpenRouteHistory = () => {
    if (isRegistrationsPage) {
      window.dispatchEvent(new CustomEvent("agilzap:open-route-history"));
    } else {
      history.push("/cadastro?openRouteHistory=1");
    }
  };
  const desktopShellNavItems = useMemo(
    () => [
      {
        value: "tickets",
        label: "Conversas",
        icon: <WhatsAppIcon />,
      },
      {
        value: "registrations",
        label: "Cadastro",
        icon: <AssignmentIndIcon />,
      },
      {
        value: "billing",
        label: "Cobrança",
        icon: <LocalAtmIcon />,
      },
      {
        value: "new-ticket",
        label: "+",
        icon: <AddCircleOutlineIcon />,
        primary: true,
      },
      {
        value: "tools",
        label: "Ferramentas",
        icon: <BuildOutlinedIcon />,
      },
      {
        value: "count",
        label: "Contagem",
        icon: <BarChartIcon />,
      },
      {
        value: "visitas",
        label: "Visitas",
        icon: <PersonAddIcon />,
      },
      {
        value: "clientes-app",
        label: "Clientes do App",
        icon: <SmartphoneIcon />,
      },
      {
        value: "motoboys",
        label: "Motoboys",
        icon: <AssignmentIndIcon />,
      },
    ].filter((item) => {
      if (!isXaiLeadUser) {
        return true;
      }

      return item.value === "tickets";
    }),
    [isXaiLeadUser]
  );

  const persistMainScrollPosition = useCallback((path, scrollTop) => {
    if (!path) {
      return;
    }

    const nextPositions = {
      ...mainScrollPositionsRef.current,
      [path]: Math.max(0, Number(scrollTop || 0))
    };

    mainScrollPositionsRef.current = nextPositions;
    writeMainScrollStorage(nextPositions);
  }, []);

  useEffect(() => {
    const mainElement = mainContentRef.current;

    if (!mainElement) {
      return undefined;
    }

    const pathKey = location.pathname || "/";
    const handleScroll = () => {
      persistMainScrollPosition(pathKey, mainElement.scrollTop);
    };

    mainElement.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();

    return () => {
      persistMainScrollPosition(pathKey, mainElement.scrollTop);
      mainElement.removeEventListener("scroll", handleScroll);
    };
  }, [location.pathname, persistMainScrollPosition]);

  useEffect(() => {
    const mainElement = mainContentRef.current;

    if (!mainElement) {
      return undefined;
    }

    const targetScrollTop = Math.max(
      0,
      Number(mainScrollPositionsRef.current[location.pathname || "/"] || 0)
    );

    if (targetScrollTop <= 0) {
      mainElement.scrollTop = 0;
      return undefined;
    }

    const restoreScrollPosition = () => {
      mainElement.scrollTop = targetScrollTop;
    };

    const rafId =
      typeof window !== "undefined"
        ? window.requestAnimationFrame(restoreScrollPosition)
        : null;
    const timeoutId = setTimeout(restoreScrollPosition, 120);

    return () => {
      if (rafId !== null && typeof window !== "undefined") {
        window.cancelAnimationFrame(rafId);
      }
      clearTimeout(timeoutId);
    };
  }, [location.pathname]);

  // Motoboy chips — ordered by drag preference
  const orderedMotoboyUsers = useMemo(() => {
    if (!chipOrder.length) return motoboyUsers;
    return [...motoboyUsers].sort((a, b) => {
      const ai = chipOrder.indexOf(a.id);
      const bi = chipOrder.indexOf(b.id);
      if (ai === -1 && bi === -1) return 0;
      if (ai === -1) return 1;
      if (bi === -1) return -1;
      return ai - bi;
    });
  }, [motoboyUsers, chipOrder]);

  const handleChipDragStart = (idx) => { dragChipIdx.current = idx; };

  const handleChipDragOver = (e, idx) => {
    e.preventDefault();
    const from = dragChipIdx.current;
    if (from === null || from === idx) return;
    const next = [...orderedMotoboyUsers];
    const [moved] = next.splice(from, 1);
    next.splice(idx, 0, moved);
    dragChipIdx.current = idx;
    const newOrder = next.map(u => u.id);
    setChipOrder(newOrder);
    localStorage.setItem("motoboyChipOrder", JSON.stringify(newOrder));
  };

  const handleChipDragEnd = () => { dragChipIdx.current = null; };

  const handleChipClick = (mu) => {
    history.push(`/tickets?whatsapp=${mu.restrictedToWhatsappId}`);
  };

  const handleChipContextMenu = (e, mu) => {
    e.preventDefault();
    e.stopPropagation();
    const conn = whatsApps.find(w => w.id === mu.restrictedToWhatsappId) || null;
    setChipContextMenu({ mouseX: e.clientX, mouseY: e.clientY, mu, conn });
  };

  const handleCloseChipMenu = () => setChipContextMenu(null);

  const runChipAction = async (fn) => {
    setChipActionLoading(true);
    handleCloseChipMenu();
    try { await fn(); } catch (err) { toastError(err); } finally { setChipActionLoading(false); }
  };

  const handleChipForceLogout = () => {
    const { mu } = chipContextMenu;
    runChipAction(async () => {
      await api.post(`/users/${mu.id}/force-logout`);
      toast.success("Usuário desconectado!");
    });
  };

  const handleChipToggleLoginBlock = () => {
    const { mu } = chipContextMenu;
    runChipAction(async () => {
      await api.post(`/users/${mu.id}/toggle-login-block`);
      setMotoboyUsers(prev => prev.map(u => u.id === mu.id ? { ...u, loginBlocked: !u.loginBlocked } : u));
      toast.success(mu.loginBlocked ? "Login liberado!" : "Login bloqueado!");
    });
  };

  const handleChipCloseTickets = () => {
    const { mu } = chipContextMenu;
    const whatsappId = mu?.restrictedToWhatsappId;
    if (!whatsappId) return;
    runChipAction(async () => {
      const { data } = await api.post(`/whatsapps/${whatsappId}/close-tickets`);
      toast.success(`${data.closed} tickets encerrados!`);
    });
  };

  const handleChipClearList = () => {
    const { mu } = chipContextMenu;
    const whatsappId = mu?.restrictedToWhatsappId;
    if (!whatsappId) return;
    runChipAction(async () => {
      await api.post(`/whatsapps/${whatsappId}/clear-list`);
      toast.success("Mensagem automática ativada! Novos contatos serão respondidos automaticamente.");
    });
  };

  const handleChipRestoreList = () => {
    const { mu } = chipContextMenu;
    const whatsappId = mu?.restrictedToWhatsappId;
    if (!whatsappId) return;
    runChipAction(async () => {
      await api.post(`/whatsapps/${whatsappId}/restore-list`);
      toast.success("Mensagem automática desativada! Conexão voltou ao normal.");
    });
  };

  const handleChipArchive = () => {
    const { mu } = chipContextMenu;
    const whatsappId = mu?.restrictedToWhatsappId;
    if (!whatsappId) return;
    runChipAction(async () => {
      const { data } = await api.post(`/whatsapps/${whatsappId}/archive-tickets`);
      toast.success(`${data.closed} tickets arquivados. Mensagens ignoradas até nova rota.`);
    });
  };

  const handleChipUnarchive = () => {
    const { mu } = chipContextMenu;
    const whatsappId = mu?.restrictedToWhatsappId;
    if (!whatsappId) return;
    runChipAction(async () => {
      await api.post(`/whatsapps/${whatsappId}/unarchive-tickets`);
      toast.success("Arquivamento removido! Conexão voltou ao normal.");
    });
  };

  const handleChipOpenAllContacts = () => {
    const { mu } = chipContextMenu;
    const whatsappId = mu?.restrictedToWhatsappId;
    if (!whatsappId) return;
    runChipAction(async () => {
      const { data } = await api.post(`/whatsapps/${whatsappId}/open-all-contacts`);
      toast.success(`${data.created} tickets abertos para todos os contatos!`);
    });
  };

  const handleMobileRegistrationExport = useCallback((eventName) => {
    if (typeof window !== "undefined") {
      window.dispatchEvent(new CustomEvent(eventName));
    }
    setMobileToolsOpen(false);
  }, []);

  const renderDuePreviewList = (items = [], emptyText = "Sem registros.") => {
    if (!Array.isArray(items) || items.length === 0) {
      return (
        <Typography variant="body2" color="textSecondary">
          {emptyText}
        </Typography>
      );
    }

    return (
      <div className={classes.duePreviewList}>
        {items.map((item, index) => (
          <div
            key={`${item.registrationId || "reg"}-${item.contactId || "ct"}-${index}`}
            className={classes.duePreviewItem}
          >
            {(() => {
              const isPaid = String(item.reminderType || "").toLowerCase() === "paid";
              const valueCents = isPaid
                ? Number(item.paidCents || 0)
                : Number(item.missingCents || 0);
              const label = isPaid ? "Pago" : "Falta";

              return (
                <>
                  <div>
                    <Typography variant="body2" style={{ fontWeight: 700 }}>
                      {item.contactName || "Sem nome"}
                    </Typography>
                    <Typography variant="caption" color="textSecondary">
                      {formatPreviewPhone(item.number)}
                    </Typography>
                  </div>
                  <div style={{ textAlign: "right" }}>
                    <Typography variant="body2" style={{ fontWeight: 700 }}>
                      {formatPreviewCurrency(valueCents)}
                    </Typography>
                    <Typography variant="caption" color="textSecondary">
                      {label}
                    </Typography>
                  </div>
                </>
              );
            })()}
          </div>
        ))}
      </div>
    );
  };

  const toolsDrawerContent = (
    <>
      {isRegistrationsPage && (
        <div className={classes.mobileToolsQuickActions}>
          <Button
            variant="outlined"
            color="primary"
            className={classes.mobileToolsQuickButton}
            onClick={() =>
              handleMobileRegistrationExport(REGISTRATION_EXPORT_SPREADSHEET_EVENT)
            }
          >
            Exportar planilha
          </Button>
          <Button
            variant="outlined"
            color="primary"
            className={classes.mobileToolsQuickButton}
            onClick={() =>
              handleMobileRegistrationExport(REGISTRATION_EXPORT_OVERDUE_EVENT)
            }
          >
            Exportar devendo/falta
          </Button>
        </div>
      )}
      <List
        className={
          showDesktopShellRail
            ? classes.desktopToolsDrawerList
            : classes.mobileToolsList
        }
      >
        <MainListItems collapsed={false} drawerClose={handleCloseMobileTools} />
      </List>
    </>
  );

  if (loading) {
    return <BackdropLoading />;
  }

  return (
    <div
      className={clsx(classes.root, "logged-in-layout")}
      style={{
        "--mobile-bottom-nav-height": showMobileBottomNavigation
          ? "calc(74px + env(safe-area-inset-bottom, 0px))"
          : "0px"
      }}
    >
      <NewTicketModal
        modalOpen={newTicketModalOpen}
        onClose={handleCloseMobileNewTicket}
        initialSearchParam={newTicketInitialNumber}
      />

      {!hideMenu && !isMobile && !showDesktopShellRail && (
        <Drawer
          variant={drawerVariant}
          className={drawerOpen ? classes.drawerPaper : classes.drawerPaperClose}
          classes={{
            paper: clsx(
              classes.drawerPaper,
              !drawerOpen && classes.drawerPaperClose
            ),
          }}
          open={drawerOpen}
        >
          <div className={classes.toolbarIcon}>
            <img
              className={drawerOpen ? classes.logo : classes.hideLogo}
              style={{
                display: "block",
                margin: "0 auto",
                height: "50px",
                width: "100%",
              }}
              alt="logo"
            />
            <IconButton onClick={() => setDrawerOpen(!drawerOpen)}>
              <ChevronLeftIcon />
            </IconButton>
          </div>
          <List className={classes.containerWithScroll}>
            {/* {mainListItems} */}
            <MainListItems collapsed={!drawerOpen} drawerClose={drawerClose} />
          </List>
          <Divider />
        </Drawer>
      )}

      {!hideConversationTopShortcuts && isEquipeChatMobileApp() && !isRegistrationsPage && (
        <>
        <div className={classes.telegramHeaderWrap}>
          <div className={classes.telegramHeaderRow}>
            <div
              style={{ position: "absolute", left: 10, top: "50%", transform: "translateY(-50%)", background: "rgba(255,255,255,0.12)", borderRadius: 14, padding: "6px 14px", cursor: "pointer" }}
              onClick={() => { setTelegramEditMode(!telegramEditMode); }}
            >
              <span style={{ color: "#2AABEE", fontSize: 17, fontWeight: 600, lineHeight: 1 }}>
                {telegramEditMode ? "Pronto" : "Editar"}
              </span>
            </div>
            <div style={{
              display: "inline-flex", alignItems: "center",
              background: "rgba(255,255,255,0.12)",
              borderRadius: 20,
              padding: "5px 18px",
            }}>
              <span className={classes.telegramHeaderName} style={{ fontSize: 20, fontWeight: 700 }}>
                {telegramEditMode && telegramSelectedCount > 0
                  ? `${telegramSelectedCount} selecionado${telegramSelectedCount > 1 ? "s" : ""}`
                  : String(user?.name || "").split(" ")[0] || "Chats"}
              </span>
            </div>
            {!telegramEditMode && (
              <div className={classes.telegramComposeWrap}>
                <div
                  className={classes.telegramComposeBtn}
                  style={{ width: 40, height: 40, borderRadius: 12 }}
                  onClick={(e) => setComposeMenuAnchor(e.currentTarget)}
                >
                  <CreateIcon style={{ fontSize: 22 }} />
                </div>
              </div>
            )}
          </div>
          {/* telegramSearchRow removido — busca real no topControlsContainer de TicketsManagerTabs */}
        </div>
        <Menu
          anchorEl={composeMenuAnchor}
          open={Boolean(composeMenuAnchor)}
          onClose={() => setComposeMenuAnchor(null)}
          PaperProps={{ style: { borderRadius: 14, minWidth: 220, marginTop: 4 } }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        >
          <MenuItem onClick={() => { setComposeMenuAnchor(null); setNewTicketModalOpen(true); }}>
            Nova Conversa
          </MenuItem>
          <Divider style={{ margin: "4px 0" }} />
          <MenuItem
            onClick={() => {
              setComposeMenuAnchor(null);
              handleBiometricToggle();
            }}
            style={{ justifyContent: "space-between" }}
          >
            <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <span style={{ fontSize: 16 }}>{biometryType === 2 ? "🫦" : "👆"}</span>
              Login com {biometryType === 2 ? "Face ID" : biometryType === 1 ? "Touch ID" : "Biometria"}
            </span>
            <Switch
              checked={biometricEnabled}
              size="small"
              color="primary"
              onClick={e => e.stopPropagation()}
            />
          </MenuItem>
          <MenuItem onClick={() => { setComposeMenuAnchor(null); setUserModalOpen(true); }}>
            <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <span style={{ fontSize: 16 }}>👤</span>
              Meu Perfil
            </span>
          </MenuItem>
          <MenuItem onClick={() => { setComposeMenuAnchor(null); handleLogout(); }} style={{ color: "#e57373" }}>
            <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <span style={{ fontSize: 16 }}>🚪</span>
              Sair
            </span>
          </MenuItem>
        </Menu>
        </>
      )}

      {!hideConversationTopShortcuts && !isEquipeChatMobileApp() && (
        <AppBar
          position="absolute"
          className={clsx(
            classes.appBar,
            !hideMenu &&
              !isMobile &&
              !showDesktopShellRail &&
              drawerOpen &&
              classes.appBarShift
          )}
          color="primary"
        >
          <Toolbar variant="dense" className={classes.toolbar}>
            {!hideMenu && !isMobile && !showDesktopShellRail && (
              <IconButton
                edge="start"
                variant="contained"
                aria-label="open drawer"
                style={{ color: "white" }}
                onClick={() => setDrawerOpen(!drawerOpen)}
                className={clsx(drawerOpen && classes.menuButtonHidden)}
                style={{ color: "inherit" }}
              >
                <MenuIcon />
              </IconButton>
            )}

            <Typography
              component="h2"
              variant="h6"
              color="inherit"
              noWrap
              className={classes.title}
              style={{ flexGrow: 0, marginRight: 12 }}
            >
              AgilZap
            </Typography>

            {user?.profile === "admin" && !isMobile && fichasMonitor && (
              <>
              <FichasMonitorStrip data={fichasMonitor} dotClass={classes.fichasLiveDot} onOpenDetail={setFichasDetailKind} />
              <FichasMonitorDialog
                open={Boolean(fichasDetailKind)}
                kind={fichasDetailKind}
                data={fichasMonitor}
                onClose={() => setFichasDetailKind(null)}
                onOpenFicha={(c) => {
                  setFichasDetailKind(null);
                  history.push(`/registrations?openRegistration=1&contactId=${c.c}&registrationId=${c.r}`);
                }}
              />
              </>
            )}

            {/* Status dos funcionários — oculto (07/10/2026, pedido do usuário: atrapalhava
                os botões das folhas de Pix/Solte na barra). Dados/lógica continuam intactos,
                só a exibição foi desligada. */}
            {false && user?.profile === "admin" && !isMobile && orderedMotoboyUsers.length > 0 && (
              <div style={{
                flex: 1,
                display: "flex",
                alignItems: "center",
                gap: 5,
                flexWrap: "nowrap",
                overflow: "hidden",
                minWidth: 0,
              }}>
                {orderedMotoboyUsers.map((mu, idx) => {
                  const isOnline = mu.online === true;
                  const shortName = String(mu.name || "").split(" ")[0];
                  const isBlocked = mu.loginBlocked === true;
                  const conn = whatsApps.find(w => w.id === mu.restrictedToWhatsappId);
                  const isCleared = Boolean(conn?.clearedAt);
                  const isArchived = Boolean(conn?.archivedAt);
                  return (
                    <span
                      key={mu.id}
                      draggable
                      onDragStart={() => handleChipDragStart(idx)}
                      onDragOver={(e) => handleChipDragOver(e, idx)}
                      onDragEnd={handleChipDragEnd}
                      onClick={() => handleChipClick(mu)}
                      onContextMenu={(e) => handleChipContextMenu(e, mu)}
                      title={`${mu.name} — ${isOnline ? "Online" : "Offline"}${isBlocked ? " 🔒 Login bloqueado" : ""}${isCleared ? " 📵 Mensagem automática ativa" : ""}${isArchived ? " 📦 Arquivado" : ""}\nClique para abrir conversas\nClique direito para opções`}
                      style={{
                        background: isOnline ? "#2e7d32" : "#b71c1c",
                        color: "#fff",
                        borderRadius: 20,
                        padding: "2px 9px",
                        fontSize: "0.65rem",
                        fontWeight: 700,
                        whiteSpace: "nowrap",
                        border: `1.5px solid ${isOnline ? "#66bb6a" : "#ef5350"}`,
                        boxShadow: isOnline ? "0 0 6px 1px rgba(102,187,106,0.55)" : "none",
                        transition: "background 0.4s, box-shadow 0.4s",
                        flexShrink: 0,
                        cursor: "pointer",
                        outline: isArchived ? "2px dashed #7b1fa2" : isCleared ? "2px dashed #ff8f00" : "none",
                        userSelect: "none",
                      }}
                    >
                      {isArchived ? "📦 " : isCleared ? "📵 " : isBlocked ? "🔒 " : ""}● {shortName}
                    </span>
                  );
                })}
              </div>
            )}

            {/* Espaçador quando não há chips (mantém botões à direita) */}
            {!(user?.profile === "admin" && !isMobile && orderedMotoboyUsers.length > 0) && (
              <div style={{ flex: 1 }} />
            )}

            {!hideMenu && (
              <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                {/* 29/10/2026 (pedido do usuário): Interior e Capital viraram UMA folha só
                    (dado antigo migrado, ver merge-folha-solte-interior-into-geral.ts) -
                    o botão separado "Interior" saiu daqui. */}
                <Tooltip
                  title={
                    soltePendingCapital > 0
                      ? `Folhas de Solte para imprimir (${soltePendingCapital})`
                      : "Folha de Solte"
                  }
                >
                  <IconButton
                    onClick={() => setSolteSheetRegiao("capital")}
                    aria-label="folha de solte"
                    color="inherit"
                    className={classes.toolbarButton}
                  >
                    <Badge badgeContent={soltePendingCapital > 0 ? soltePendingCapital : null} color="error">
                      <span style={{ position: "relative", display: "inline-flex" }}>
                        <ReceiptIcon />
                        <span
                          style={{
                            position: "absolute",
                            bottom: -3,
                            right: -3,
                            width: 13,
                            height: 13,
                            borderRadius: "50%",
                            background: "#ef5350",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            boxShadow: "0 0 0 1.5px #0c3b2e"
                          }}
                        >
                          <ArrowDownwardIcon style={{ fontSize: 9, color: "#fff" }} />
                        </span>
                      </span>
                    </Badge>
                  </IconButton>
                </Tooltip>
                <SolteSheetModal
                  open={Boolean(solteSheetRegiao)}
                  regiao={solteSheetRegiao}
                  onClose={() => setSolteSheetRegiao(null)}
                  onChanged={(dados) => {
                    const pendentes = Number(dados?.pendentes) || 0;
                    setSoltePendingCapital(pendentes);
                  }}
                />
                <Tooltip
                  title={
                    pixSheetsPending > 0
                      ? `Folhas de Pix para imprimir (${pixSheetsPending})`
                      : "Pix Recebidos"
                  }
                >
                  <IconButton
                    onClick={() => setPixSheetOpen(true)}
                    aria-label="pix recebidos"
                    color="inherit"
                    className={classes.toolbarButton}
                  >
                    <Badge
                      badgeContent={pixSheetsPending > 0 ? pixSheetsPending : null}
                      color="error"
                    >
                      <span style={{ position: "relative", display: "inline-flex" }}>
                        <ReceiptIcon />
                        <span
                          style={{
                            position: "absolute",
                            bottom: -3,
                            right: -3,
                            width: 13,
                            height: 13,
                            borderRadius: "50%",
                            background: "#66bb6a",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            boxShadow: "0 0 0 1.5px #0c3b2e"
                          }}
                        >
                          <ArrowUpwardIcon style={{ fontSize: 9, color: "#fff" }} />
                        </span>
                      </span>
                    </Badge>
                  </IconButton>
                </Tooltip>
                <PixSheetModal
                  open={pixSheetOpen}
                  onClose={() => setPixSheetOpen(false)}
                  onChanged={(dados) => setPixSheetsPending(Number(dados?.pendentes) || 0)}
                />
                <Tooltip
                  title={
                    routeMarkedCount > 0
                      ? `Conferir rotas enviadas (${routeMarkedCount})`
                      : "Conferir rotas enviadas"
                  }
                >
                  <IconButton
                    onClick={handleOpenRouteSheet}
                    aria-label="conferir rotas enviadas"
                    color="inherit"
                    className={classes.toolbarButton}
                  >
                    <Badge
                      badgeContent={routeMarkedCount > 0 ? routeMarkedCount : null}
                      color="error"
                    >
                      <MotorcycleIcon />
                    </Badge>
                  </IconButton>
                </Tooltip>
                <Tooltip title="Histórico de rotas (qualquer dia)">
                  <IconButton
                    onClick={handleOpenRouteHistory}
                    aria-label="histórico de rotas"
                    color="inherit"
                    className={classes.toolbarButton}
                  >
                    <CalendarTodayIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Recarregar página">
                  <IconButton
                    onClick={() => window.location.reload()}
                    aria-label="recarregar página"
                    color="inherit"
                    className={classes.toolbarButton}
                  >
                    <RefreshIcon />
                  </IconButton>
                </Tooltip>
                <IconButton
                  onClick={handleMenu}
                  aria-label="abrir menu do perfil"
                  color="inherit"
                  className={classes.toolbarButton}
                >
                  <MoreVertIcon />
                </IconButton>
                <div className="user-menu-wrapper">
                  <StyledBadge
                    overlap="circular"
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "right",
                    }}
                    variant="dot"
                    onClick={handleMenu}
                  >
                    <Avatar
                      alt="Multi100"
                      className={classes.avatar2}
                      src={profileUrl}
                    />
                  </StyledBadge>

                  <UserModal
                    open={userModalOpen}
                    onClose={() => setUserModalOpen(false)}
                    onImageUpdate={(newProfileUrl) => setProfileUrl(newProfileUrl)}
                    userId={user?.id}
                  />

                  <Menu
                    id="menu-appbar"
                    anchorEl={anchorEl}
                    getContentAnchorEl={null}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "right",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    open={menuOpen}
                    onClose={handleCloseMenu}
                    PaperProps={{
                      style: {
                        minWidth: "150px",
                        maxWidth: "200px",
                        width: "auto",
                      },
                    }}
                  >
                    <MenuItem onClick={handleOpenUserModal}>
                      {i18n.t("mainDrawer.appBar.user.profile")}
                    </MenuItem>
                    <MenuItem onClick={(e) => { setFontPopoverAnchor(e.currentTarget); handleCloseMenu(); }}>
                      <FormatSizeIcon style={{ marginRight: 8, fontSize: 18 }} />
                      Ajustes de Fonte
                    </MenuItem>
                    {isBiometricSupported() && (
                      <MenuItem onClick={handleBiometricToggle} style={{ justifyContent: "space-between" }}>
                        <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
                          <span style={{ fontSize: 16 }}>{biometryType === 2 ? "🫦" : "👆"}</span>
                          Login com {getBiometryLabel(biometryType)}
                        </span>
                        <Switch
                          checked={biometricEnabled}
                          size="small"
                          color="primary"
                          onClick={e => e.stopPropagation()}
                          onChange={handleBiometricToggle}
                        />
                      </MenuItem>
                    )}
                    {showNotifToggle && (
                      <MenuItem onClick={handleNotifToggle} style={{ justifyContent: "space-between" }} disabled={notifLoading}>
                        <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
                          <span style={{ fontSize: 16 }}>🔔</span>
                          Notificações
                        </span>
                        <Switch
                          checked={notifEnabled}
                          size="small"
                          color="primary"
                          onClick={e => e.stopPropagation()}
                          onChange={handleNotifToggle}
                          disabled={notifLoading}
                        />
                      </MenuItem>
                    )}
                    <MenuItem onClick={handleClickLogout}>
                      {i18n.t("mainDrawer.appBar.user.logout")}
                    </MenuItem>
                  </Menu>
                  <Popover
                    open={Boolean(fontPopoverAnchor)}
                    anchorEl={fontPopoverAnchor}
                    onClose={() => setFontPopoverAnchor(null)}
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                    transformOrigin={{ vertical: "top", horizontal: "right" }}
                    PaperProps={{ style: { padding: "16px 24px 12px", minWidth: 260 } }}
                  >
                    <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 12 }}>
                      <FormatSizeIcon style={{ fontSize: 16, opacity: 0.7 }} />
                      <Typography variant="body2" style={{ fontWeight: 600 }}>Tamanho da Fonte</Typography>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                      <Typography variant="caption" style={{ minWidth: 20 }}>A</Typography>
                      <Slider
                        value={fontScale}
                        min={75}
                        max={140}
                        step={5}
                        onChange={(_, val) => setFontScale(val)}
                        style={{ flex: 1 }}
                      />
                      <Typography variant="body1" style={{ minWidth: 20 }}>A</Typography>
                    </div>
                    <Typography variant="caption" style={{ display: "block", textAlign: "center", opacity: 0.6, marginTop: 4 }}>
                      {fontScale}%
                    </Typography>
                  </Popover>
                </div>
              </div>
            )}
          </Toolbar>
        </AppBar>
      )}

      {/* Biometric login setup dialog */}
      <Dialog open={biometricDialogOpen} onClose={() => setBiometricDialogOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle>Ativar Login com Digital</DialogTitle>
        <DialogContent>
          <Typography variant="body2" style={{ marginBottom: 16 }}>
            Confirme sua senha para ativar o login por impressão digital.
          </Typography>
          <TextField
            label="Senha"
            type="password"
            variant="outlined"
            fullWidth
            size="small"
            value={biometricPassword}
            onChange={e => setBiometricPassword(e.target.value)}
            onKeyDown={e => e.key === "Enter" && handleBiometricSave()}
            autoFocus
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setBiometricDialogOpen(false)} disabled={biometricLoading}>
            Cancelar
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleBiometricSave}
            disabled={biometricLoading || !biometricPassword.trim()}
          >
            {biometricLoading ? <CircularProgress size={18} /> : "Ativar"}
          </Button>
        </DialogActions>
      </Dialog>

      {showDesktopShellRail && (
        <aside className={classes.desktopShellRail}>
          {!hideConversationTopShortcuts && (
            <div className={classes.desktopShellRailSpacer} />
          )}
          <div className={classes.desktopShellRailContent}>
            <div className={classes.desktopShellBrand}>
              <div className={classes.desktopShellBrandMark}>A</div>
            </div>

            <div className={classes.desktopShellNavList}>
              {desktopShellNavItems.map((item) => {
                const isSelected = desktopShellNavigationValue === item.value;

                return (
                  <Tooltip key={item.value} title={item.label} placement="right">
                    <ButtonBase
                      type="button"
                      onClick={() => handleMobileNavigation(null, item.value)}
                      className={clsx(
                        classes.desktopShellNavButton,
                        isSelected && "selected",
                        item.primary && classes.desktopShellNavButtonPrimary
                      )}
                    >
                      {item.icon}
                    </ButtonBase>
                  </Tooltip>
                );
              })}
            </div>
          </div>
        </aside>
      )}

      <main
        ref={mainContentRef}
        className={clsx(
          classes.content,
          showMobileBottomNavigation && (isEquipeChatMobileApp() ? classes.contentWithMobileNavTelegram : classes.contentWithMobileNav),
          hideConversationTopShortcuts && classes.contentTicketConversationMobile
        )}
      >
        {!hideConversationTopShortcuts && (
          <div style={{
            minHeight: !isEquipeChatMobileApp()
              ? "48px"
              : isRegistrationsPage
                ? "0px"
                : "calc(57px + env(safe-area-inset-top, 0px))"
          }} />
        )}
        {children ? children : null}
      </main>

      {showDesktopShellRail && (
        <Drawer
          anchor="left"
          open={mobileToolsOpen}
          onClose={handleCloseMobileTools}
          classes={{ paper: classes.desktopToolsDrawerPaper }}
          ModalProps={{ keepMounted: true }}
        >
          <div className={classes.desktopToolsDrawerHeader}>
            <Typography className={classes.mobileToolsTitle}>
              Ferramentas
            </Typography>
            <IconButton onClick={handleCloseMobileTools}>
              <CloseIcon />
            </IconButton>
          </div>
          {toolsDrawerContent}
        </Drawer>
      )}

      {showMobileBottomNavigation && (
        <>
          <Drawer
            anchor="bottom"
            open={mobileToolsOpen}
            onClose={handleCloseMobileTools}
            classes={{ paper: classes.mobileToolsDrawerPaper }}
            ModalProps={{ keepMounted: true }}
          >
            <div className={classes.mobileToolsHandle} />
            <div className={classes.mobileToolsHeader}>
              <Typography className={classes.mobileToolsTitle}>
                Ferramentas
              </Typography>
              <IconButton onClick={handleCloseMobileTools}>
                <CloseIcon />
              </IconButton>
            </div>
            {toolsDrawerContent}
          </Drawer>

          <div className={classes.bottomNavCover} />
          {isEquipeChatMobileApp() && !isTicketConversation && <div className={classes.mobileTopGradient} />}
          {isEquipeChatMobileApp() && !isTicketConversation && <div className={classes.mobileBottomGradient} />}
          <div className={isEquipeChatMobileApp() ? classes.mobileBottomNavShellTelegram : classes.mobileBottomNavShell}>
            <BottomNavigation
              showLabels={!isTicketConversation}
              value={mobileNavigationValue}
              onChange={handleMobileNavigation}
              className={isEquipeChatMobileApp() ? classes.mobileBottomNavTelegram : classes.mobileBottomNav}
              style={isEquipeChatMobileApp() ? { justifyContent: "center" } : undefined}
            >
              {isEquipeChatMobileApp() && isRestrictedUser ? (
                <>
                  {user?.allowBillingMobile ? (
                    /* Restrito com acesso financeiro: Cadastro + Cobrança + Chats + rotas + config */
                    <>
                      <BottomNavigationAction
                        value="registrations"
                        label="Cadastro"
                        icon={<ContactsOutlinedIcon />}
                        className={classes.mobileBottomNavActionTelegram}
                        onClick={() => { setMobileToolsOpen(false); history.push("/registrations"); }}
                      />
                      <BottomNavigationAction
                        value="billing"
                        label="Cobrança"
                        icon={<MonetizationOnOutlinedIcon />}
                        className={classes.mobileBottomNavActionTelegram}
                        onClick={() => { setMobileToolsOpen(false); history.push("/registrations-billing"); }}
                      />
                      <BottomNavigationAction
                        value="tickets"
                        label="Chats"
                        icon={
                          <GreenCountBadge badgeContent={unreadConversationCount} max={99}>
                            <ChatBubbleOutlineIcon />
                          </GreenCountBadge>
                        }
                        className={classes.mobileBottomNavActionTelegram}
                        onClick={() => { setMobileToolsOpen(false); history.push("/tickets"); }}
                      />
                      <BottomNavigationAction
                        value="new-ticket"
                        label=""
                        icon={<AddCircleOutlineIcon />}
                        className={classes.mobileBottomNavActionTelegram}
                        onClick={() => { setMobileToolsOpen(false); setNewTicketModalOpen(true); }}
                      />
                      <BottomNavigationAction
                        value="couriers"
                        label="Rotas"
                        icon={<MotorcycleOutlinedIcon />}
                        className={classes.mobileBottomNavActionTelegram}
                        onClick={() => { setMobileToolsOpen(false); history.push("/couriers"); }}
                      />
                      <BottomNavigationAction
                        value="tools"
                        label="Config."
                        icon={<SettingsOutlinedIcon />}
                        className={classes.mobileBottomNavActionTelegram}
                        onClick={() => setMobileToolsOpen(true)}
                      />
                    </>
                  ) : (
                    /* Funcionário simples (ex: itamar): só Chats (sem badge) + lápis */
                    <>
                      <BottomNavigationAction
                        value="tickets"
                        label="Chats"
                        icon={<ChatBubbleOutlineIcon />}
                        className={classes.mobileBottomNavActionTelegram}
                        onClick={() => { setMobileToolsOpen(false); history.push("/tickets"); }}
                      />
                      <BottomNavigationAction
                        value="new-ticket"
                        label=""
                        icon={<AddCircleOutlineIcon />}
                        className={classes.mobileBottomNavActionTelegram}
                        onClick={() => { setMobileToolsOpen(false); setNewTicketModalOpen(true); }}
                      />
                    </>
                  )}
                </>
              ) : isEquipeChatMobileApp() ? (
                <>
                  <BottomNavigationAction
                    value="registrations"
                    label="Cadastro"
                    icon={<ContactsOutlinedIcon />}
                    className={classes.mobileBottomNavActionTelegram}
                    onClick={() => { setMobileToolsOpen(false); history.push("/registrations"); }}
                  />
                  <BottomNavigationAction
                    value="billing"
                    label="Cobrança"
                    icon={<MonetizationOnOutlinedIcon />}
                    className={classes.mobileBottomNavActionTelegram}
                    onClick={() => { setMobileToolsOpen(false); history.push("/registrations-billing"); }}
                  />
                  <BottomNavigationAction
                    value="tickets"
                    label="Chats"
                    icon={
                      <GreenCountBadge badgeContent={unreadConversationCount} max={99}>
                        <ChatBubbleOutlineIcon />
                      </GreenCountBadge>
                    }
                    className={classes.mobileBottomNavActionTelegram}
                    onClick={() => { setMobileToolsOpen(false); history.push("/tickets"); }}
                  />
                  <BottomNavigationAction
                    value="tools"
                    label="Config."
                    icon={<SettingsOutlinedIcon />}
                    className={classes.mobileBottomNavActionTelegram}
                    onClick={() => setMobileToolsOpen(true)}
                  />
                </>
              ) : (
                <>
                  <BottomNavigationAction
                    value="tickets"
                    label="Conversas"
                    icon={
                      <GreenCountBadge badgeContent={unreadConversationCount} max={99}>
                        <WhatsAppIcon />
                      </GreenCountBadge>
                    }
                    className={classes.mobileBottomNavAction}
                    onClick={() => { setMobileToolsOpen(false); history.push("/tickets"); }}
                  />
                  <BottomNavigationAction
                    value="registrations"
                    label="Cadastro"
                    icon={<AssignmentIndIcon />}
                    className={classes.mobileBottomNavAction}
                    onClick={() => { setMobileToolsOpen(false); history.push("/registrations"); }}
                  />
                  <BottomNavigationAction
                    value="billing"
                    label="Cobrança"
                    icon={<LocalAtmIcon />}
                    className={classes.mobileBottomNavAction}
                    onClick={() => { setMobileToolsOpen(false); history.push("/registrations-billing"); }}
                  />
                  <BottomNavigationAction
                    value="tools"
                    label="Ferramentas"
                    icon={<BuildOutlinedIcon />}
                    className={classes.mobileBottomNavAction}
                    onClick={() => setMobileToolsOpen(true)}
                  />
                </>
              )}
            </BottomNavigation>
          </div>
        </>
      )}

      {/* Modal de Informativos */}
      <Dialog
        open={showAnnouncementsModal}
        onClose={() => setShowAnnouncementsModal(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Informativos</DialogTitle>
        <DialogContent dividers>
          {selectedAnnouncement ? (
            <div>
              <Typography variant="h6" gutterBottom>
                {selectedAnnouncement.title}
              </Typography>
              <Typography variant="body1" style={{ whiteSpace: 'pre-line' }}>
                {selectedAnnouncement.text}
              </Typography>
              {selectedAnnouncement.mediaPath && (
                <div style={{ marginTop: 16 }}>
                  <img
                    src={`${backendUrl}/public/company${user.companyId}${selectedAnnouncement.mediaPath}`}
                    alt="Anexo"
                    style={{ maxWidth: '100%' }}
                  />
                </div>
              )}
              <Button
                onClick={() => setSelectedAnnouncement(null)}
                style={{ marginTop: 16 }}
                variant="outlined"
              >
                Voltar para lista
              </Button>
            </div>
          ) : (
            <List>
              {announcements.map((announcement) => (
                <ListItem
                  button
                  key={announcement.id}
                  onClick={() => setSelectedAnnouncement(announcement)}
                >
                  <ListItemAvatar>
                    <Avatar>
                      <NotificationsIcon />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={announcement.title}
                    secondary={
                      <>
                        <Typography
                          component="span"
                          variant="body2"
                          color="textPrimary"
                        >
                          Prioridade: {announcement.priority === 1 ? 'Alta' : announcement.priority === 2 ? 'Média' : 'Baixa'}
                        </Typography>
                        {` — ${new Date(announcement.createdAt).toLocaleDateString()}`}
                      </>
                    }
                  />
                </ListItem>
              ))}
            </List>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setShowAnnouncementsModal(false)}
            color="primary"
          >
            Fechar
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal de Aniversário */}
      <BirthdayModal
        open={showBirthdayModal}
        onClose={() => setShowBirthdayModal(false)}
        user={user}
      />

      <Dialog
        open={duePreviewOpen}
        onClose={() => {}}
        disableBackdropClick
        disableEscapeKeyDown
        maxWidth="md"
        fullWidth
        fullScreen={!greaterThenSm}
      >
        <DialogTitle>Previsao de cobranca do dia</DialogTitle>
        <DialogContent dividers>
          <Typography variant="body2" color="textSecondary" style={{ marginBottom: 12 }}>
            Baseado na virada do dia e pagamentos das ultimas 24h.
          </Typography>
          <Typography variant="caption" color="textSecondary" style={{ display: "block", marginBottom: 12 }}>
            Gerado em:{" "}
            {duePreviewData?.generatedAt
              ? new Date(duePreviewData.generatedAt).toLocaleString("pt-BR")
              : "-"}
          </Typography>

          <div className={classes.duePreviewSummaryWrap}>
            <div className={classes.duePreviewSummaryCard}>
              <Typography variant="caption" color="textSecondary">
                Total no dia
              </Typography>
              <Typography variant="h6">
                {Number(duePreviewData?.summary?.totalDue || 0)}
              </Typography>
            </div>
            <div className={classes.duePreviewSummaryCard}>
              <Typography variant="caption" color="textSecondary">
                Serao cobrados
              </Typography>
              <Typography variant="h6">
                {Number(duePreviewData?.summary?.willChargeCount || 0)}
              </Typography>
            </div>
            <div className={classes.duePreviewSummaryCard}>
              <Typography variant="caption" color="textSecondary">
                Pago parcial
              </Typography>
              <Typography variant="h6">
                {Number(duePreviewData?.summary?.paidPartialCount || 0)}
              </Typography>
            </div>
            <div className={classes.duePreviewSummaryCard}>
              <Typography variant="caption" color="textSecondary">
                Pago completo
              </Typography>
              <Typography variant="h6">
                {Number(duePreviewData?.summary?.paidFullCount || 0)}
              </Typography>
            </div>
          </div>

          <Typography className={classes.duePreviewSectionTitle}>
            Serao cobrados agora (sem pagamento)
          </Typography>
          {renderDuePreviewList(
            duePreviewData?.chargeFull || [],
            "Nenhum cliente sem pagamento para cobrar."
          )}

          <Typography className={classes.duePreviewSectionTitle}>
            Pagaram parcial (ainda falta)
          </Typography>
          {renderDuePreviewList(
            duePreviewData?.paidPartial || [],
            "Nenhum pagamento parcial identificado."
          )}

          <Typography className={classes.duePreviewSectionTitle}>
            Pagaram completo
          </Typography>
          {renderDuePreviewList(
            duePreviewData?.paidFull || [],
            "Nenhum pagamento completo identificado."
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDuePreviewAcknowledge} color="primary">
            Entendi
          </Button>
        </DialogActions>
      </Dialog>

      {/* Context menu dos chips de funcionário */}
      <Menu
        open={Boolean(chipContextMenu)}
        onClose={handleCloseChipMenu}
        anchorReference="anchorPosition"
        anchorPosition={
          chipContextMenu
            ? { top: chipContextMenu.mouseY, left: chipContextMenu.mouseX }
            : undefined
        }
      >
        <MenuItem disabled style={{ opacity: 1, paddingTop: 4, paddingBottom: 4 }}>
          <strong>{chipContextMenu?.mu?.name}</strong>
          {chipContextMenu?.mu?.online === true ? " 🟢" : " 🔴"}
        </MenuItem>
        <MenuItem
          onClick={handleChipForceLogout}
          disabled={chipContextMenu?.mu?.online !== true || chipActionLoading}
          style={{ color: "#c62828" }}
        >
          Fazer Logoff
        </MenuItem>
        <MenuItem
          onClick={handleChipToggleLoginBlock}
          disabled={chipActionLoading}
          style={{ color: chipContextMenu?.mu?.loginBlocked ? "#1a6644" : "#e65100" }}
        >
          {chipContextMenu?.mu?.loginBlocked ? "Liberar Login" : "Bloquear Login"}
        </MenuItem>
        <MenuItem
          onClick={handleChipCloseTickets}
          disabled={chipActionLoading || !chipContextMenu?.mu?.restrictedToWhatsappId}
        >
          Encerrar Tickets
        </MenuItem>
        {chipContextMenu?.conn?.clearedAt ? (
          <MenuItem
            onClick={handleChipRestoreList}
            disabled={chipActionLoading}
            style={{ color: "#1a6644" }}
          >
            📵 Desativar Mensagem Automática
          </MenuItem>
        ) : (
          <MenuItem
            onClick={handleChipClearList}
            disabled={chipActionLoading || !chipContextMenu?.mu?.restrictedToWhatsappId}
            style={{ color: "#c62828" }}
          >
            📵 Ativar Mensagem Automática
          </MenuItem>
        )}
        {chipContextMenu?.conn?.archivedAt ? (
          <MenuItem
            onClick={handleChipUnarchive}
            disabled={chipActionLoading}
            style={{ color: "#6a1b9a" }}
          >
            📦 Desarquivar Conexão
          </MenuItem>
        ) : (
          <MenuItem
            onClick={handleChipArchive}
            disabled={chipActionLoading || !chipContextMenu?.mu?.restrictedToWhatsappId}
            style={{ color: "#4a148c" }}
          >
            📦 Arquivar Todos os Tickets exceto Grupos
          </MenuItem>
        )}
        <MenuItem
          onClick={handleChipOpenAllContacts}
          disabled={chipActionLoading || !chipContextMenu?.mu?.restrictedToWhatsappId}
          style={{ color: "#1565c0" }}
        >
          📋 Abrir Tickets de Todos os Contatos
        </MenuItem>
      </Menu>

      <PWAInstallPrompt hasMobileBottomNav={showMobileBottomNavigation} />
      <WebPushManager />

    </div>
  );
};

export default LoggedInLayout;
